/* eslint-disable */
import { CaseRating } from '@faceup/utils';
import { TrialLength } from '@faceup/utils';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Allowed characters in user name */
  AllowedUserName: { input: string; output: string; }
  /** global id of Attachment */
  AttachmentGlobalId: { input: string; output: string; }
  BCP47Language: { input: string; output: string; }
  Base64UrlSafe: { input: string; output: string; }
  Color: { input: string; output: string; }
  /** Opaque cursor for internal comment pagination */
  CommentThreadCursor: { input: string; output: string; }
  /** global id of CompanyReportCategory */
  CompanyReportCategoryGlobalId: { input: string; output: string; }
  /** global id of CompanyReportFollowUpComment */
  CompanyReportFollowUpCommentGlobalId: { input: string; output: string; }
  /** global id of CompanyReportInternalComment */
  CompanyReportInternalCommentGlobalId: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Email: { input: string; output: string; }
  EncryptionVersion: { input: number; output: number; }
  /** global id of FormItem */
  FormItemGlobalId: { input: string; output: string; }
  /** global id of FormItemOption */
  FormItemOptionGlobalId: { input: string; output: string; }
  GraphQLCaseRating: { input: CaseRating; output: CaseRating; }
  GraphQLDeadlinesInterval: { input: number; output: number; }
  GraphQLDeleteReportsMonthInterval: { input: number; output: number; }
  GraphQLInstitutionPassword: { input: string; output: string; }
  GraphQLLongString: { input: string; output: string; }
  GraphQLLongStringLength: { input: number; output: number; }
  GraphQLMediumString: { input: string; output: string; }
  GraphQLNonNegativeInt: { input: number; output: number; }
  GraphQLOpaqueShortId: { input: string; output: string; }
  GraphQLPositiveInt: { input: number; output: number; }
  /** An integer value between 0 and 10 */
  GraphQLScaleValue: { input: number; output: number; }
  GraphQLShortString: { input: string; output: string; }
  GraphQLShortestString: { input: string; output: string; }
  GraphQLStarCount: { input: number; output: number; }
  GraphQLString: { input: string; output: string; }
  GraphQLText: { input: string; output: string; }
  GraphQLTrialLength: { input: TrialLength; output: TrialLength; }
  IpAddress: { input: string; output: string; }
  JSON: { input: { [key: string]: any }; output: { [key: string]: any }; }
  /** global id of MemberNotification */
  MemberNotificationGlobalId: { input: string; output: string; }
  Phone: { input: string; output: string; }
  /** global id of PublicReportSource */
  PublicReportSourceGlobalId: { input: string; output: string; }
  /** global id of ReportSource */
  ReportSourceGlobalId: { input: string; output: string; }
  UUID: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File | Blob; output: File | Blob; }
  Url: { input: string; output: string; }
  WorkingHour: { input: string; output: string; }
};

/** If you want to omit an answer, omit the entire object, do not send empty arrays or null values */
export type AF_AnswerInput = {
  /** File uploads for a file field, or voice recordings for a text field that supports them (MoreInformation, SimpleText, MultilineText); null otherwise */
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Non-empty array if the form item is a matrix field, null otherwise */
  matrixValues?: InputMaybe<Array<AF_MatrixValuesInput>>;
  /** Non-empty array if the form item is a select field and the option is not the other option, null otherwise */
  optionIds?: InputMaybe<Array<Scalars['FormItemOptionGlobalId']['input']>>;
  /** String required if the form item is a text field, also used for other option for select fields, null otherwise */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type AF_CreateMatrixFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isMultipleSelectionAllowed: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  labelTranslations: Array<AF_TranslationInput>;
  options: Array<AF_CreateMatrixItemInput>;
  questions: Array<AF_CreateMatrixItemInput>;
  type: FormItemType;
};

export type AF_CreateMatrixItemInput = {
  labelTranslations: Array<AF_TranslationInput>;
};

export type AF_CreateMultiSelectFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  hasOtherOption: Scalars['Boolean']['input'];
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isRequired: Scalars['Boolean']['input'];
  labelTranslations: Array<AF_TranslationInput>;
  maxResponses?: InputMaybe<Scalars['GraphQLPositiveInt']['input']>;
  minResponses?: InputMaybe<Scalars['GraphQLNonNegativeInt']['input']>;
  options: Array<AF_CreateSelectOptionInput>;
  type: FormItemType;
};

export type AF_CreateMultilineTextFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isRequired: Scalars['Boolean']['input'];
  labelTranslations: Array<AF_TranslationInput>;
  maxLength?: InputMaybe<Scalars['GraphQLLongStringLength']['input']>;
  type: FormItemType;
};

export type AF_CreateRatingFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isRequired: Scalars['Boolean']['input'];
  labelTranslations: Array<AF_TranslationInput>;
  numberOfStars: Scalars['GraphQLStarCount']['input'];
  type: FormItemType;
};

export type AF_CreateReportFormInput = {
  defaultLanguage: Language;
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type AF_CreateReportSubmissionInput = {
  answers: Array<AF_AnswerInput>;
  body: Scalars['Base64UrlSafe']['input'];
  bodyNonce: Scalars['Base64UrlSafe']['input'];
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  formId: Scalars['UUID']['input'];
  nonce: Scalars['Base64UrlSafe']['input'];
  organizationalUnitId: Scalars['UUID']['input'];
  password: Scalars['GraphQLInstitutionPassword']['input'];
  passwordPrehash: Scalars['GraphQLString']['input'];
  privateKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  publicKey: Scalars['Base64UrlSafe']['input'];
  recipientKeys: Array<MemberReportKeys>;
  salt: Scalars['Base64UrlSafe']['input'];
  senderKey: Scalars['Base64UrlSafe']['input'];
};

export type AF_CreateScaleFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  end: AF_ScaleBoundaryInput;
  formId: Scalars['UUID']['input'];
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isRequired: Scalars['Boolean']['input'];
  labelTranslations: Array<AF_TranslationInput>;
  start: AF_ScaleBoundaryInput;
  type: FormItemType;
};

export type AF_CreateSelectFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  hasOtherOption: Scalars['Boolean']['input'];
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isRequired: Scalars['Boolean']['input'];
  labelTranslations: Array<AF_TranslationInput>;
  options: Array<AF_CreateSelectOptionInput>;
  type: FormItemType;
};

export type AF_CreateSelectOptionInput = {
  labelTranslations: Array<AF_TranslationInput>;
};

export type AF_CreateSimpleFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isRequired: Scalars['Boolean']['input'];
  labelTranslations: Array<AF_TranslationInput>;
  type: FormItemType;
};

export type AF_DeleteFormItemInput = {
  formItemId: Scalars['FormItemGlobalId']['input'];
};

export type AF_EditMatrixFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  /** The ID of the form item to edit */
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  isMultipleSelectionAllowed: Scalars['Boolean']['input'];
  /** Whether the form item is required in the categories */
  isRequired: Scalars['Boolean']['input'];
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
  options: Array<AF_EditMatrixItemInput>;
  questions: Array<AF_EditMatrixItemInput>;
};

export type AF_EditMatrixItemInput = {
  /** ID of the option to edit, or undefined to create a new option */
  id?: InputMaybe<Scalars['UUID']['input']>;
  labelTranslations: Array<AF_TranslationInput>;
};

export type AF_EditMultiSelectFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  /** The ID of the form item to edit */
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Whether the select form item should include an "Other" option */
  hasOtherOption: Scalars['Boolean']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  /** Whether the form item is required in the categories */
  isRequired: Scalars['Boolean']['input'];
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
  maxResponses?: InputMaybe<Scalars['GraphQLPositiveInt']['input']>;
  minResponses?: InputMaybe<Scalars['GraphQLNonNegativeInt']['input']>;
  /** List of options for the select form item, including translations, order, and IDs for existing options */
  options: Array<AF_EditSelectOptionInput>;
};

export type AF_EditMultilineTextFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  /** The ID of the form item to edit */
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  /** Whether the form item is required in the categories */
  isRequired: Scalars['Boolean']['input'];
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
  /** If null, resets to the default value of 10000 */
  maxLength?: InputMaybe<Scalars['GraphQLLongStringLength']['input']>;
};

export type AF_EditRatingFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  /** The ID of the form item to edit */
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  /** Whether the form item is required in the categories */
  isRequired: Scalars['Boolean']['input'];
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
  numberOfStars: Scalars['GraphQLStarCount']['input'];
};

export type AF_EditReportingFormLanguagesInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  /** The new default language for the reporting form */
  defaultLanguage: Language;
  /** The new list of languages for the reporting form */
  languages: Array<Language>;
};

export type AF_EditScaleFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  end: AF_ScaleBoundaryInput;
  formId: Scalars['UUID']['input'];
  /** The ID of the form item to edit */
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  /** Whether the form item is required in the categories */
  isRequired: Scalars['Boolean']['input'];
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
  start: AF_ScaleBoundaryInput;
};

export type AF_EditSelectFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  /** The ID of the form item to edit */
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Whether the select form item should include an "Other" option */
  hasOtherOption: Scalars['Boolean']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  /** Whether the form item is required in the categories */
  isRequired: Scalars['Boolean']['input'];
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
  /** List of options for the select form item, including translations, order, and IDs for existing options */
  options: Array<AF_EditSelectOptionInput>;
};

export type AF_EditSelectOptionInput = {
  /** ID of the option to edit, or null to create a new option */
  id?: InputMaybe<Scalars['FormItemOptionGlobalId']['input']>;
  labelTranslations: Array<AF_TranslationInput>;
};

export type AF_EditSimpleFormItemInput = {
  /** For forms without categories, send null (not an empty array). */
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  /** The ID of the form item to edit */
  formItemId: Scalars['FormItemGlobalId']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  /** Whether the form item is required in the categories */
  isRequired: Scalars['Boolean']['input'];
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
};

export type AF_FormItemReorderItemInput = {
  formItemId: Scalars['FormItemGlobalId']['input'];
  order: Scalars['Int']['input'];
};

export type AF_MatrixValuesInput = {
  optionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  questionId: Scalars['UUID']['input'];
};

export type AF_ReorderFormItemInput = {
  formId: Scalars['UUID']['input'];
  items: Array<AF_FormItemReorderItemInput>;
};

export type AF_ScaleBoundaryInput = {
  labelTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  value: Scalars['GraphQLScaleValue']['input'];
};

export type AF_SetRequiredFormItemInput = {
  formId: Scalars['UUID']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  isRequired: Scalars['Boolean']['input'];
};

export type AF_TranslationInput = {
  language: Language;
  translation: Scalars['String']['input'];
};

export type AF_editChannelCategoriesInput = {
  /** not CompanyReportCategoryGlobalIdType because AF_GraphQLFormCustomizationType#items */
  categoryIds?: InputMaybe<Array<Scalars['FormItemOptionGlobalId']['input']>>;
  formId: Scalars['UUID']['input'];
  /** Optional translations for the form item hint in all supported languages */
  hintTranslations?: InputMaybe<Array<AF_TranslationInput>>;
  /** Translations for the form item label in all supported languages */
  labelTranslations: Array<AF_TranslationInput>;
};

export enum AccountType {
  Owner = 'Owner',
  Regular = 'Regular'
}

export type AddAllowedIpAddressInput = {
  configId: Scalars['UUID']['input'];
  description: Scalars['GraphQLShortString']['input'];
  ipAddress: Scalars['IpAddress']['input'];
};

export type AddFormItemToCategoryInput = {
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
};

export type AddPartnerUserInput = {
  email: Scalars['Email']['input'];
  partnerId: Scalars['UUID']['input'];
};

export type AnswerInput = {
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  formItemId: Scalars['FormItemGlobalId']['input'];
  matrixValues?: InputMaybe<Array<MatrixValuesInput>>;
  /** For select null means redacted */
  values?: InputMaybe<Array<Scalars['GraphQLString']['input']>>;
};

export type ApproveAiHotlineInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  phoneNumber: Scalars['Float']['input'];
};

export type ApproveAutomatedHotlineInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  phoneNumber: Scalars['Float']['input'];
};

export type ApproveLiveHotlineInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  phoneNumber: Scalars['Float']['input'];
};

export type ApprovePartnerRegistrationInput = {
  partnerId: Scalars['UUID']['input'];
};

export type ApproveSchoolRegistrationInput = {
  companyId: Scalars['UUID']['input'];
};

export type AvaPlaceWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type AwsHandleTranscriptInput = {
  jobName: Scalars['GraphQLString']['input'];
  jobStatus: Scalars['GraphQLString']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type BackgroundProcessOrderBy = {
  key: BackgroundProcessOrderByPossibleKeys;
  order: OrderByKeyword;
};

export enum BackgroundProcessOrderByPossibleKeys {
  created_at = 'created_at'
}

export enum BillingFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly'
}

export type CancelScheduledSubscriptionChangeInput = {
  motherId: Scalars['UUID']['input'];
};

export enum CaseClosingReason {
  Custom = 'Custom',
  Other = 'Other',
  Rejected = 'Rejected',
  Resolved = 'Resolved',
  Spam = 'Spam'
}

export enum CaseCreationOrigin {
  Member = 'Member',
  Redaction = 'Redaction',
  Reporter = 'Reporter'
}

export enum CaseDeadlineFilter {
  Later = 'Later',
  Overdue = 'Overdue',
  Soon = 'Soon',
  Today = 'Today'
}

export enum CaseJustification {
  Justified = 'Justified',
  Unjustified = 'Unjustified',
  Unknown = 'Unknown'
}

export enum CasePriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Urgent = 'Urgent'
}

export enum CaseSourceType {
  AiHotline = 'AiHotline',
  AutomatedHotline = 'AutomatedHotline',
  Email = 'Email',
  InPerson = 'InPerson',
  LiveHotline = 'LiveHotline',
  Other = 'Other',
  Phone = 'Phone',
  ReportingSystem = 'ReportingSystem',
  Survey = 'Survey'
}

export enum CaseStatusGroup {
  Closed = 'Closed',
  New = 'New',
  Open = 'Open'
}

export type CaseStatusTranslation = {
  language: Language;
  translation: Scalars['GraphQLShortestString']['input'];
};

export type ChangeCaseStatusOrderInput = {
  caseStatusId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  newOrder: Scalars['Int']['input'];
};

export type ChangeFormItemOrderInput = {
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  /**
   *
   *         Essentially, this number is an answer to the question:
   *           "How many form items (not considering me) should be included before me?"
   *         Consider example (always type, then current order):
   *           - Category, 0
   *           - OrganizationalUnit, 1
   *           - MoreInfo, 2
   *           - SimpleText, 3
   *
   *         If i want to swap more info with simple text, you can either do:
   *           - changeFormItemOrder({ formItemId: <moreInfo.id>, newOrder: 3 }) or
   *           - changeFormItemOrder({ formItemId: <simpleText.id>, newOrder: 2})
   *
   */
  newOrder: Scalars['Int']['input'];
};

export type ChangePageOrderInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  language: Language;
  newPagesOrders: Array<NewPageOrderType>;
};

export type ChangePartnerFormItemOrderInput = {
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  newOrder: Scalars['Int']['input'];
};

export type ChangeSubscriptionInput = {
  billingFrequency: BillingFrequency;
  employees: Scalars['Int']['input'];
  motherId: Scalars['UUID']['input'];
  plan: Plan;
};

export type ChangeTrialSubscriptionInput = {
  billingFrequency: BillingFrequency;
  employees: Scalars['Int']['input'];
  motherId: Scalars['UUID']['input'];
  plan: Plan;
};

export enum ChannelPageType {
  AfterSend = 'AfterSend',
  BeforeSend = 'BeforeSend',
  FormItems = 'FormItems'
}

export enum ChannelStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export enum ChannelType {
  AiHotline = 'AiHotline',
  AutomatedHotline = 'AutomatedHotline',
  LiveHotline = 'LiveHotline',
  ReportingSystem = 'ReportingSystem',
  Survey = 'Survey'
}

export enum ChargebeeSubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Future = 'Future',
  InTrial = 'InTrial',
  NonRenewing = 'NonRenewing',
  Paused = 'Paused'
}

export type ChargebeeWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type ChatMessageInput = {
  /** attachments stream */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  ciphertext: Scalars['Base64UrlSafe']['input'];
  nonce: Scalars['Base64UrlSafe']['input'];
  originalCommentId: Scalars['CompanyReportFollowUpCommentGlobalId']['input'];
};

export type CheckCompanyReportDeadlinesInput = {
  token: Scalars['GraphQLString']['input'];
};

export type CheckInvestigationDueDatesInput = {
  token: Scalars['GraphQLString']['input'];
};

export type CheckPasswordTokensInput = {
  token: Scalars['GraphQLString']['input'];
};

export type CloseInvestigationInput = {
  investigationId: Scalars['UUID']['input'];
};

export type CloseReportInput = {
  caseId: Scalars['UUID']['input'];
};

export type CollectUnfinishedRegistrationsInput = {
  token: Scalars['GraphQLString']['input'];
  window: UnfinishedRegistrationsWindow;
};

export enum CompanyAuditLogActionName {
  AssignMembers = 'AssignMembers',
  ChangedAccessors = 'ChangedAccessors',
  ChangedCategory = 'ChangedCategory',
  ChangedDeadline = 'ChangedDeadline',
  ChangedDeadlineDone = 'ChangedDeadlineDone',
  ChangedInternalComment = 'ChangedInternalComment',
  ChangedLabel = 'ChangedLabel',
  CreateReport = 'CreateReport',
  DeletedInternalComment = 'DeletedInternalComment',
  EditClosingJustification = 'EditClosingJustification',
  EditFormItemAnswer = 'EditFormItemAnswer',
  EditHiddenFromStatistics = 'EditHiddenFromStatistics',
  EditJustification = 'EditJustification',
  EditPriority = 'EditPriority',
  EditReport = 'EditReport',
  EditStatus = 'EditStatus',
  Export = 'Export',
  ImportedReport = 'ImportedReport',
  InvestigationClosed = 'InvestigationClosed',
  InvestigationDeleted = 'InvestigationDeleted',
  InvestigationFirstChange = 'InvestigationFirstChange',
  InvestigationInitiated = 'InvestigationInitiated',
  ReportChangedCompany = 'ReportChangedCompany',
  RestrictRecipient = 'RestrictRecipient'
}

export type CompanyReportCategoryOrderType = {
  id: Scalars['CompanyReportCategoryGlobalId']['input'];
  order: Scalars['Int']['input'];
};

export type ConnectDeelInput = {
  code: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type ConnectTeamsInput = {
  code: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type ConnectUkgProInput = {
  api: Scalars['GraphQLShortString']['input'];
  hostname: Scalars['GraphQLShortString']['input'];
  motherId: Scalars['UUID']['input'];
  password: Scalars['GraphQLShortString']['input'];
  username: Scalars['GraphQLShortString']['input'];
};

export enum ContactIssue {
  BuyMaxVariantBasic = 'BuyMaxVariantBasic',
  BuyMaxVariantFree = 'BuyMaxVariantFree',
  BuyMaxVariantPremium = 'BuyMaxVariantPremium',
  BuyMaxVariantStandard = 'BuyMaxVariantStandard',
  ContactAfterTrial = 'ContactAfterTrial',
  ContactDuringTrial = 'ContactDuringTrial',
  ContactLicenceStartInFuture = 'ContactLicenceStartInFuture',
  ContactViaBilling = 'ContactViaBilling',
  OldPricing = 'OldPricing',
  Unknown = 'Unknown',
  Upsell = 'Upsell'
}

export type ContactSalesByEmailInput = {
  issue: ContactIssue;
  message: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['GraphQLString']['input']>;
  subject: Scalars['GraphQLString']['input'];
};

export type ContactSalesByPhoneInput = {
  issue: ContactIssue;
  motherId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['GraphQLString']['input']>;
  phone: Scalars['GraphQLString']['input'];
};

export enum Country {
  Ad = 'Ad',
  Ae = 'Ae',
  Af = 'Af',
  Ag = 'Ag',
  Ai = 'Ai',
  Al = 'Al',
  Am = 'Am',
  Ao = 'Ao',
  Aq = 'Aq',
  Ar = 'Ar',
  As = 'As',
  At = 'At',
  Au = 'Au',
  Aw = 'Aw',
  Ax = 'Ax',
  Az = 'Az',
  Ba = 'Ba',
  Bb = 'Bb',
  Bd = 'Bd',
  Be = 'Be',
  Bf = 'Bf',
  Bg = 'Bg',
  Bh = 'Bh',
  Bi = 'Bi',
  Bj = 'Bj',
  Bl = 'Bl',
  Bm = 'Bm',
  Bn = 'Bn',
  Bo = 'Bo',
  Bq = 'Bq',
  Br = 'Br',
  Bs = 'Bs',
  Bt = 'Bt',
  Bv = 'Bv',
  Bw = 'Bw',
  By = 'By',
  Bz = 'Bz',
  Ca = 'Ca',
  Cc = 'Cc',
  Cd = 'Cd',
  Cf = 'Cf',
  Cg = 'Cg',
  Ch = 'Ch',
  Ci = 'Ci',
  Ck = 'Ck',
  Cl = 'Cl',
  Cm = 'Cm',
  Cn = 'Cn',
  Co = 'Co',
  Cr = 'Cr',
  Cu = 'Cu',
  Cv = 'Cv',
  Cw = 'Cw',
  Cx = 'Cx',
  Cy = 'Cy',
  Cz = 'Cz',
  De = 'De',
  Dj = 'Dj',
  Dk = 'Dk',
  Dm = 'Dm',
  Do = 'Do',
  Dz = 'Dz',
  Ec = 'Ec',
  Ee = 'Ee',
  Eg = 'Eg',
  Eh = 'Eh',
  Er = 'Er',
  Es = 'Es',
  Et = 'Et',
  Fi = 'Fi',
  Fj = 'Fj',
  Fk = 'Fk',
  Fm = 'Fm',
  Fo = 'Fo',
  Fr = 'Fr',
  Ga = 'Ga',
  Gb = 'Gb',
  Gd = 'Gd',
  Ge = 'Ge',
  Gf = 'Gf',
  Gg = 'Gg',
  Gh = 'Gh',
  Gi = 'Gi',
  Gl = 'Gl',
  Gm = 'Gm',
  Gn = 'Gn',
  Gp = 'Gp',
  Gq = 'Gq',
  Gr = 'Gr',
  Gs = 'Gs',
  Gt = 'Gt',
  Gu = 'Gu',
  Gw = 'Gw',
  Gy = 'Gy',
  Hk = 'Hk',
  Hm = 'Hm',
  Hn = 'Hn',
  Hr = 'Hr',
  Ht = 'Ht',
  Hu = 'Hu',
  Id = 'Id',
  Ie = 'Ie',
  Il = 'Il',
  Im = 'Im',
  In = 'In',
  Io = 'Io',
  Iq = 'Iq',
  Ir = 'Ir',
  Is = 'Is',
  It = 'It',
  Je = 'Je',
  Jm = 'Jm',
  Jo = 'Jo',
  Jp = 'Jp',
  Ke = 'Ke',
  Kg = 'Kg',
  Kh = 'Kh',
  Ki = 'Ki',
  Km = 'Km',
  Kn = 'Kn',
  Kp = 'Kp',
  Kr = 'Kr',
  Kw = 'Kw',
  Ky = 'Ky',
  Kz = 'Kz',
  La = 'La',
  Lb = 'Lb',
  Lc = 'Lc',
  Li = 'Li',
  Lk = 'Lk',
  Lr = 'Lr',
  Ls = 'Ls',
  Lt = 'Lt',
  Lu = 'Lu',
  Lv = 'Lv',
  Ly = 'Ly',
  Ma = 'Ma',
  Mc = 'Mc',
  Md = 'Md',
  Me = 'Me',
  Mf = 'Mf',
  Mg = 'Mg',
  Mh = 'Mh',
  Mk = 'Mk',
  Ml = 'Ml',
  Mm = 'Mm',
  Mn = 'Mn',
  Mo = 'Mo',
  Mp = 'Mp',
  Mq = 'Mq',
  Mr = 'Mr',
  Ms = 'Ms',
  Mt = 'Mt',
  Mu = 'Mu',
  Mv = 'Mv',
  Mw = 'Mw',
  Mx = 'Mx',
  My = 'My',
  Mz = 'Mz',
  Na = 'Na',
  Nc = 'Nc',
  Ne = 'Ne',
  Nf = 'Nf',
  Ng = 'Ng',
  Ni = 'Ni',
  Nl = 'Nl',
  No = 'No',
  Np = 'Np',
  Nr = 'Nr',
  Nu = 'Nu',
  Nz = 'Nz',
  Om = 'Om',
  Pa = 'Pa',
  Pe = 'Pe',
  Pf = 'Pf',
  Pg = 'Pg',
  Ph = 'Ph',
  Pk = 'Pk',
  Pl = 'Pl',
  Pm = 'Pm',
  Pn = 'Pn',
  Pr = 'Pr',
  Ps = 'Ps',
  Pt = 'Pt',
  Pw = 'Pw',
  Py = 'Py',
  Qa = 'Qa',
  Re = 'Re',
  Ro = 'Ro',
  Rs = 'Rs',
  Ru = 'Ru',
  Rw = 'Rw',
  Sa = 'Sa',
  Sb = 'Sb',
  Sc = 'Sc',
  Sd = 'Sd',
  Se = 'Se',
  Sg = 'Sg',
  Sh = 'Sh',
  Si = 'Si',
  Sj = 'Sj',
  Sk = 'Sk',
  Sl = 'Sl',
  Sm = 'Sm',
  Sn = 'Sn',
  So = 'So',
  Sr = 'Sr',
  Ss = 'Ss',
  St = 'St',
  Sv = 'Sv',
  Sx = 'Sx',
  Sy = 'Sy',
  Sz = 'Sz',
  Tc = 'Tc',
  Td = 'Td',
  Tf = 'Tf',
  Tg = 'Tg',
  Th = 'Th',
  Tj = 'Tj',
  Tk = 'Tk',
  Tl = 'Tl',
  Tm = 'Tm',
  Tn = 'Tn',
  To = 'To',
  Tr = 'Tr',
  Tt = 'Tt',
  Tv = 'Tv',
  Tw = 'Tw',
  Tz = 'Tz',
  Ua = 'Ua',
  Ug = 'Ug',
  Um = 'Um',
  Us = 'Us',
  Uy = 'Uy',
  Uz = 'Uz',
  Va = 'Va',
  Vc = 'Vc',
  Ve = 'Ve',
  Vg = 'Vg',
  Vi = 'Vi',
  Vn = 'Vn',
  Vu = 'Vu',
  Wf = 'Wf',
  Ws = 'Ws',
  Ye = 'Ye',
  Yt = 'Yt',
  Za = 'Za',
  Zm = 'Zm',
  Zw = 'Zw'
}

export type CreateAdminRequestInput = {
  email: Scalars['Email']['input'];
  name: Scalars['GraphQLShortString']['input'];
  nonce: Scalars['Base64UrlSafe']['input'];
  passwordPrehash: Scalars['Base64UrlSafe']['input'];
  privateKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  publicKey: Scalars['Base64UrlSafe']['input'];
  role: FuAdminRoleType;
  salt: Scalars['Base64UrlSafe']['input'];
  token: Scalars['GraphQLString']['input'];
  totpSecret: Scalars['GraphQLString']['input'];
};

export type CreateAiHotlineOrderInput = {
  country: HotlineCountry;
  defaultLanguage: HotlineLanguage;
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLString']['input'];
  phoneNumberType: HotlinePhoneNumberType;
};

export type CreateApiKeyInput = {
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type CreateAutomatedHotlineOrderInput = {
  country: HotlineCountry;
  defaultLanguage: HotlineLanguage;
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLString']['input'];
  phoneNumberType: HotlinePhoneNumberType;
};

export type CreateCaseStatusInput = {
  color: Scalars['Color']['input'];
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortestString']['input'];
};

export type CreateClosingReasonInput = {
  name: Scalars['GraphQLShortestString']['input'];
};

export type CreateCompanyReportCategoryInput = {
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type CreateCompanyReportFollowUpCommentInput = {
  /** attachments stream */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  caseId: Scalars['UUID']['input'];
  ciphertext: Scalars['Base64UrlSafe']['input'];
  motherId: Scalars['UUID']['input'];
  nonce: Scalars['Base64UrlSafe']['input'];
};

export type CreateCompanyReportInternalCommentInput = {
  /** attachments stream */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  caseId: Scalars['UUID']['input'];
  ciphertext: Scalars['Base64UrlSafe']['input'];
  mentionedMemberIds: Array<Scalars['UUID']['input']>;
  motherId: Scalars['UUID']['input'];
  nonce: Scalars['Base64UrlSafe']['input'];
  parentCommentId?: InputMaybe<Scalars['CompanyReportInternalCommentGlobalId']['input']>;
  recipientKeys: Array<MemberReportKeys>;
};

export type CreateCompanyReportLabelInput = {
  caseId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type CreateDemoCompanyInput = {
  country: Country;
  importMockData: Scalars['Boolean']['input'];
  institutionType: Institution;
  language: Language;
  /** All members emails (at least one) */
  membersEmails: Array<Scalars['GraphQLString']['input']>;
  name: Scalars['GraphQLString']['input'];
  partnerId?: InputMaybe<Scalars['UUID']['input']>;
  requestedPlan: Plan;
  timezone: Scalars['GraphQLString']['input'];
};

export type CreateEmployeesInvolvementInput = {
  caseId: Scalars['UUID']['input'];
  employeeIds: Array<Scalars['UUID']['input']>;
  involvement: EmployeeInvolvement;
  motherId: Scalars['UUID']['input'];
};

export type CreateExportActivityLogItemInput = {
  caseIds: Array<Scalars['UUID']['input']>;
};

export type CreateExternalWebhookInput = {
  source: Scalars['GraphQLString']['input'];
  token: Scalars['GraphQLString']['input'];
  type: WebhookType;
  url: Scalars['Url']['input'];
};

export type CreateFormInput = {
  defaultLanguage: Language;
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLString']['input'];
};

export type CreateFormItemInput = {
  addToCategoriesIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired: Scalars['Boolean']['input'];
  label: Scalars['GraphQLMediumString']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  type: FormItemType;
};

export type CreateInternalMaterialInput = {
  file: Scalars['Upload']['input'];
  generatedDocument: MaterialGenerationType;
  institution: Institution;
  isForSchoolDefaultForm: Scalars['Boolean']['input'];
  isFree: Scalars['Boolean']['input'];
  language: Language;
  name: Scalars['GraphQLString']['input'];
  type: MaterialType;
  withActivePassword: Scalars['Boolean']['input'];
};

export type CreateMemberInput = {
  companyIds: Array<Scalars['UUID']['input']>;
  email: Scalars['Email']['input'];
  motherId: Scalars['UUID']['input'];
  permissions: Array<PermissionInput>;
};

export type CreateMemberReportInput = {
  answers: Array<AnswerInput>;
  /** Attachments */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  body: Scalars['Base64UrlSafe']['input'];
  bodyNonce: Scalars['Base64UrlSafe']['input'];
  caseStatusId: Scalars['UUID']['input'];
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  createdAt: Scalars['DateTime']['input'];
  organizationalUnitId: Scalars['UUID']['input'];
  recipientKeys: Array<MemberReportKeys>;
  reportSourceId: Scalars['ReportSourceGlobalId']['input'];
  source: CaseSourceType;
};

export type CreateOAuthBambooHrUrlInput = {
  hostname: Scalars['GraphQLShortString']['input'];
  motherId: Scalars['UUID']['input'];
};

export type CreateOAuthSlackUrlInput = {
  motherId: Scalars['UUID']['input'];
};

export type CreateOAuthUkgReadyUrlInput = {
  companyId: Scalars['GraphQLShortString']['input'];
  motherId: Scalars['UUID']['input'];
};

export type CreateOrganizationalUnitInput = {
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLString']['input'];
  parentOrganizationalUnitId: Scalars['UUID']['input'];
};

export type CreatePageInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  content: Scalars['GraphQLText']['input'];
  icon: Scalars['GraphQLString']['input'];
  language: Language;
  title: Scalars['GraphQLShortString']['input'];
};

export type CreatePartnerFormItemInput = {
  addToCategoriesIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired: Scalars['Boolean']['input'];
  label: Scalars['GraphQLMediumString']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  type: FormItemType;
};

export type CreatePartnerPortalSessionInput = {
  partnerId: Scalars['UUID']['input'];
};

export type CreatePartnerReportCategoryInput = {
  configId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type CreatePaymentUrlInput = {
  allowOfflinePaymentMethods: Scalars['Boolean']['input'];
  motherId: Scalars['UUID']['input'];
};

export type CreatePortalSessionInput = {
  motherId: Scalars['UUID']['input'];
};

export type CreateRedactedReportInput = {
  answers: Array<AnswerInput>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  body: Scalars['Base64UrlSafe']['input'];
  bodyNonce: Scalars['Base64UrlSafe']['input'];
  closingReasonId?: InputMaybe<Scalars['UUID']['input']>;
  followUpMessages: Array<ChatMessageInput>;
  internalComments: Array<InternalMessageInput>;
  moreInfoAttachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  originalCaseId: Scalars['UUID']['input'];
  recipientKeys: Array<MemberReportKeys>;
  redactedChatUsers: Array<RedactedUserInput>;
  redactedCommentUserIds: Array<RedactedUserInput>;
  reportClosingComment?: InputMaybe<ReportClosingType>;
};

export type CreateReportInput = {
  answers: Array<AnswerInput>;
  /** attachments stream */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  body: Scalars['Base64UrlSafe']['input'];
  bodyNonce: Scalars['Base64UrlSafe']['input'];
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  companyId: Scalars['UUID']['input'];
  /** more info attachment streams (voice recordings) */
  moreInfoAttachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  nonce: Scalars['Base64UrlSafe']['input'];
  password?: InputMaybe<Scalars['GraphQLInstitutionPassword']['input']>;
  passwordPrehash: Scalars['GraphQLString']['input'];
  privateKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  publicKey: Scalars['Base64UrlSafe']['input'];
  recipientKeys: Array<MemberReportKeys>;
  reportSourceId: Scalars['PublicReportSourceGlobalId']['input'];
  salt: Scalars['Base64UrlSafe']['input'];
  senderKey: Scalars['Base64UrlSafe']['input'];
};

export type CreateScaleFormItemInput = {
  addToCategoriesIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  end: NewScaleFormItemOption;
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired: Scalars['Boolean']['input'];
  label: Scalars['GraphQLMediumString']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  start: NewScaleFormItemOption;
  type: FormItemType;
};

export type CreateSelectFormItemInput = {
  addToCategoriesIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired: Scalars['Boolean']['input'];
  label: Scalars['GraphQLMediumString']['input'];
  options: Array<NewFormItemOptionInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type: FormItemType;
};

export type CreateSnippetInput = {
  content: Scalars['GraphQLMediumString']['input'];
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
  shortcut: Scalars['GraphQLShortString']['input'];
};

export type CreateSubscriptionInput = {
  billingFrequency: BillingFrequency;
  coupon?: InputMaybe<Scalars['GraphQLString']['input']>;
  employees: Scalars['Int']['input'];
  isPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  motherId: Scalars['UUID']['input'];
  plan: Plan;
};

export type CreateSurveyInput = {
  language: Language;
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type CreateSurveySubmissionInput = {
  answers: Array<AF_AnswerInput>;
  durationInMs: Scalars['Int']['input'];
  formId: Scalars['UUID']['input'];
  surveySource: SurveySource;
};

export type CreateWebhookInput = {
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLString']['input'];
  types: Array<WebhookType>;
  url: Scalars['Url']['input'];
};

export enum Currency {
  ADP = 'ADP',
  AED = 'AED',
  AFA = 'AFA',
  AFN = 'AFN',
  ALK = 'ALK',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  AOK = 'AOK',
  AON = 'AON',
  AOR = 'AOR',
  ARA = 'ARA',
  ARP = 'ARP',
  ARS = 'ARS',
  ARY = 'ARY',
  ATS = 'ATS',
  AUD = 'AUD',
  AWG = 'AWG',
  AYM = 'AYM',
  AZM = 'AZM',
  AZN = 'AZN',
  BAD = 'BAD',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BEC = 'BEC',
  BEF = 'BEF',
  BEL = 'BEL',
  BGJ = 'BGJ',
  BGK = 'BGK',
  BGL = 'BGL',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BOP = 'BOP',
  BOV = 'BOV',
  BRB = 'BRB',
  BRC = 'BRC',
  BRE = 'BRE',
  BRL = 'BRL',
  BRN = 'BRN',
  BRR = 'BRR',
  BSD = 'BSD',
  BTN = 'BTN',
  BUK = 'BUK',
  BWP = 'BWP',
  BYB = 'BYB',
  BYN = 'BYN',
  BYR = 'BYR',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHC = 'CHC',
  CHE = 'CHE',
  CHF = 'CHF',
  CHW = 'CHW',
  CLF = 'CLF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  COU = 'COU',
  CRC = 'CRC',
  CSD = 'CSD',
  CSJ = 'CSJ',
  CSK = 'CSK',
  CUC = 'CUC',
  CUP = 'CUP',
  CVE = 'CVE',
  CYP = 'CYP',
  CZK = 'CZK',
  DDM = 'DDM',
  DEM = 'DEM',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  ECS = 'ECS',
  ECV = 'ECV',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ESA = 'ESA',
  ESB = 'ESB',
  ESP = 'ESP',
  ETB = 'ETB',
  EUR = 'EUR',
  FIM = 'FIM',
  FJD = 'FJD',
  FKP = 'FKP',
  FRF = 'FRF',
  GBP = 'GBP',
  GEK = 'GEK',
  GEL = 'GEL',
  GHC = 'GHC',
  GHP = 'GHP',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNE = 'GNE',
  GNF = 'GNF',
  GNS = 'GNS',
  GQE = 'GQE',
  GRD = 'GRD',
  GTQ = 'GTQ',
  GWE = 'GWE',
  GWP = 'GWP',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRD = 'HRD',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  IEP = 'IEP',
  ILP = 'ILP',
  ILR = 'ILR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISJ = 'ISJ',
  ISK = 'ISK',
  ITL = 'ITL',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAJ = 'LAJ',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LSM = 'LSM',
  LTL = 'LTL',
  LTT = 'LTT',
  LUC = 'LUC',
  LUF = 'LUF',
  LUL = 'LUL',
  LVL = 'LVL',
  LVR = 'LVR',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MGF = 'MGF',
  MKD = 'MKD',
  MLF = 'MLF',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRO = 'MRO',
  MTL = 'MTL',
  MTP = 'MTP',
  MUR = 'MUR',
  MVQ = 'MVQ',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MXP = 'MXP',
  MXV = 'MXV',
  MYR = 'MYR',
  MZE = 'MZE',
  MZM = 'MZM',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIC = 'NIC',
  NIO = 'NIO',
  NLG = 'NLG',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEH = 'PEH',
  PEI = 'PEI',
  PEN = 'PEN',
  PES = 'PES',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PLZ = 'PLZ',
  PTE = 'PTE',
  PYG = 'PYG',
  QAR = 'QAR',
  RHD = 'RHD',
  ROK = 'ROK',
  ROL = 'ROL',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RUR = 'RUR',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDD = 'SDD',
  SDG = 'SDG',
  SDP = 'SDP',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SIT = 'SIT',
  SKK = 'SKK',
  SLL = 'SLL',
  SOS = 'SOS',
  SRD = 'SRD',
  SRG = 'SRG',
  SSP = 'SSP',
  STD = 'STD',
  SUR = 'SUR',
  SVC = 'SVC',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJR = 'TJR',
  TJS = 'TJS',
  TMM = 'TMM',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TPE = 'TPE',
  TRL = 'TRL',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UAK = 'UAK',
  UGS = 'UGS',
  UGW = 'UGW',
  UGX = 'UGX',
  USD = 'USD',
  USN = 'USN',
  USS = 'USS',
  UYI = 'UYI',
  UYN = 'UYN',
  UYP = 'UYP',
  UYU = 'UYU',
  UZS = 'UZS',
  VEB = 'VEB',
  VEF = 'VEF',
  VNC = 'VNC',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  XAF = 'XAF',
  XAG = 'XAG',
  XAU = 'XAU',
  XBA = 'XBA',
  XBB = 'XBB',
  XBC = 'XBC',
  XBD = 'XBD',
  XCD = 'XCD',
  XDR = 'XDR',
  XEU = 'XEU',
  XFO = 'XFO',
  XFU = 'XFU',
  XOF = 'XOF',
  XPD = 'XPD',
  XPF = 'XPF',
  XPT = 'XPT',
  XRE = 'XRE',
  XSU = 'XSU',
  XTS = 'XTS',
  XUA = 'XUA',
  XXX = 'XXX',
  YER = 'YER',
  YUD = 'YUD',
  YUM = 'YUM',
  YUN = 'YUN',
  ZAL = 'ZAL',
  ZAR = 'ZAR',
  ZMK = 'ZMK',
  ZMW = 'ZMW',
  ZRN = 'ZRN',
  ZRZ = 'ZRZ',
  ZWC = 'ZWC',
  ZWD = 'ZWD',
  ZWL = 'ZWL',
  ZWN = 'ZWN',
  ZWR = 'ZWR'
}

export enum Day {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DeleteAiHotlineInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  keepNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAllowedIpAddressInput = {
  configId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};

export type DeleteApiKeyInput = {
  apiKeyId: Scalars['UUID']['input'];
};

export type DeleteAutomatedHotlineInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  keepNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteCaseStatusInput = {
  caseStatusId: Scalars['UUID']['input'];
  newCaseStatusId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeleteClosingReasonInput = {
  closingReasonId: Scalars['UUID']['input'];
};

export type DeleteCompanyOpenIdInput = {
  motherId: Scalars['UUID']['input'];
};

export type DeleteCompanyReportCategoryInput = {
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  fallbackCategoryId?: InputMaybe<Scalars['CompanyReportCategoryGlobalId']['input']>;
  motherId: Scalars['UUID']['input'];
};

export type DeleteCompanyReportInternalCommentInput = {
  commentId: Scalars['CompanyReportInternalCommentGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
};

export type DeleteCompanyReportLabelInput = {
  labelId: Scalars['UUID']['input'];
};

export type DeleteCompanyRipplingSSOInput = {
  motherId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};

export type DeleteEmployeeInput = {
  employeeId: Scalars['UUID']['input'];
};

export type DeleteEmployeeInvolvementInput = {
  caseId: Scalars['UUID']['input'];
  employeeId: Scalars['UUID']['input'];
  involvement: EmployeeInvolvement;
  motherId: Scalars['UUID']['input'];
};

export type DeleteExternalWebhookInput = {
  token: Scalars['GraphQLString']['input'];
  webhookId: Scalars['UUID']['input'];
};

export type DeleteFormItemInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
};

export type DeleteInternalMaterialInput = {
  s3Key: Scalars['GraphQLString']['input'];
};

export type DeleteLiveHotlineInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
};

export type DeleteMemberCreatedReportInput = {
  caseId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
};

export type DeleteMemberInput = {
  memberId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
};

export type DeleteMemberTwoFactorAuthenticationInput = {
  memberId: Scalars['UUID']['input'];
};

export type DeleteOrganizationalUnitInput = {
  fallbackOrgUnitId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  organizationalUnitId: Scalars['UUID']['input'];
};

export type DeletePageInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  pageId: Scalars['UUID']['input'];
};

export type DeletePartnerFormItemInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
};

export type DeletePartnerInput = {
  partnerId: Scalars['UUID']['input'];
};

export type DeletePartnerUserInput = {
  partnerMemberId: Scalars['UUID']['input'];
};

export type DeleteReportingFormInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
};

export type DeleteSlackIntegrationInput = {
  motherId: Scalars['UUID']['input'];
};

export type DeleteSnippetInput = {
  motherId: Scalars['UUID']['input'];
  snippetId: Scalars['UUID']['input'];
};

export type DeleteSurveyInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
};

export type DeleteSurveySubmissionInput = {
  submissionId: Scalars['ID']['input'];
};

export type DeleteUserImageInput = {
  deleteImage: Scalars['Boolean']['input'];
};

export type DeleteWebhookInput = {
  webhookId: Scalars['UUID']['input'];
};

export type DisconnectBambooHrInput = {
  motherId: Scalars['UUID']['input'];
};

export type DisconnectDeelInput = {
  motherId: Scalars['UUID']['input'];
};

export type DisconnectPaylocityInput = {
  motherId: Scalars['UUID']['input'];
};

export type DisconnectRipplingInput = {
  motherId: Scalars['UUID']['input'];
};

export type DisconnectTeamsInput = {
  motherId: Scalars['UUID']['input'];
};

export type DisconnectUkgProInput = {
  motherId: Scalars['UUID']['input'];
};

export type DisconnectUkgReadyInput = {
  motherId: Scalars['UUID']['input'];
};

export type DisconnectVantaInput = {
  motherId: Scalars['UUID']['input'];
};

export type DuplicateSurveyInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
  newName: Scalars['GraphQLShortString']['input'];
};

export type EditAiHotlineChannelConfigurationInput = {
  categoryIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  defaultLanguage: HotlineLanguage;
  emergencyNumber?: InputMaybe<Scalars['Phone']['input']>;
  motherId: Scalars['UUID']['input'];
  organizationalUnitId: Scalars['UUID']['input'];
};

export type EditAllowedIpAddressInput = {
  configId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
  newDescription: Scalars['GraphQLShortString']['input'];
};

/** An answer of an existing case that can also drop its uploaded files */
export type EditAnswerInput = {
  /** Newly uploaded files, appended to the files the answer already has */
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Already uploaded files of this answer that should be removed */
  filesToDelete?: InputMaybe<Array<Scalars['AttachmentGlobalId']['input']>>;
  formItemId: Scalars['FormItemGlobalId']['input'];
  matrixValues?: InputMaybe<Array<MatrixValuesInput>>;
  /** For select null means redacted */
  values?: InputMaybe<Array<Scalars['GraphQLString']['input']>>;
};

export type EditAutomatedHotlineChannelConfigurationInput = {
  categoryIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  defaultLanguage: HotlineLanguage;
  languages: Array<HotlineLanguage>;
  motherId: Scalars['UUID']['input'];
  organizationalUnitIds: Array<Scalars['UUID']['input']>;
};

export type EditAutomatedHotlineChannelConfigurationTranslationsInput = {
  afterVoiceRecordingEndMessageTranslation: Scalars['GraphQLMediumString']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
  language: HotlineLanguage;
  motherId: Scalars['UUID']['input'];
  welcomeMessageTranslation: Scalars['GraphQLMediumString']['input'];
};

export type EditCaseIsHiddenFromStatisticsInput = {
  caseId: Scalars['UUID']['input'];
  isHiddenFromStatistics: Scalars['Boolean']['input'];
};

export type EditCaseStatusInput = {
  caseStatusId: Scalars['UUID']['input'];
  color: Scalars['Color']['input'];
  language: Language;
  translation: Scalars['GraphQLShortestString']['input'];
};

export type EditCaseStatusTranslationsInput = {
  caseStatusId: Scalars['UUID']['input'];
  translations: Array<CaseStatusTranslation>;
};

export type EditChannelActivePasswordInput = {
  activeReportPassword: Scalars['Boolean']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
};

export type EditChannelAfterSendInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  emailNotificationEnabled: Scalars['Boolean']['input'];
  language: Language;
  reportSentDescription: Scalars['GraphQLMediumString']['input'];
};

export type EditChannelAnonymityInput = {
  anonymityEnabled: Scalars['Boolean']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
};

export type EditChannelAppearanceInput = {
  defaultLanguage?: InputMaybe<Language>;
  /** Image stream */
  image?: InputMaybe<Scalars['Upload']['input']>;
  languages?: InputMaybe<Array<Language>>;
  logoSize?: InputMaybe<LogoSize>;
  motherId: Scalars['UUID']['input'];
  reportFormColor?: InputMaybe<Scalars['Color']['input']>;
  reportSourceId: Scalars['ReportSourceGlobalId']['input'];
};

export type EditChannelBeforeSendInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  recipientsOnReportForm: RecipientsOnReportForm;
};

export type EditChannelCategoriesInput = {
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  hasHint?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  label?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  language: Language;
  motherId: Scalars['UUID']['input'];
};

export type EditChannelFormItemTranslationsInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  hint?: InputMaybe<Array<HintTranslation>>;
  label: Array<LabelTranslation>;
  options?: InputMaybe<Array<OptionTranslations>>;
  scaleEndLabel?: InputMaybe<Array<HintTranslation>>;
  scaleStartLabel?: InputMaybe<Array<HintTranslation>>;
};

export type EditChannelNameInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type EditChannelOrganizationalUnitsInput = {
  addToCategoriesIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  hasHint?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  language: Language;
  motherId: Scalars['UUID']['input'];
  organizationalUnitIds: Array<Scalars['UUID']['input']>;
};

export type EditChannelPasswordInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
  newPassword: Scalars['GraphQLInstitutionPassword']['input'];
};

export type EditChannelShortLinkInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
  opaqueShortId: Scalars['GraphQLOpaqueShortId']['input'];
};

export type EditClientInstitutionRegistrationInput = {
  invoicedTo: InvoicedTo;
  motherId: Scalars['UUID']['input'];
};

export type EditClosingReasonInput = {
  closingReasonId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortestString']['input'];
};

export type EditClosingReasonTranslationsInput = {
  closingReasonId: Scalars['UUID']['input'];
  translations: Array<CaseStatusTranslation>;
};

export type EditCompanyAutomaticDeadlinesInput = {
  automaticDeadlines: Scalars['Boolean']['input'];
  automaticDeadlinesInterval?: InputMaybe<Scalars['GraphQLDeadlinesInterval']['input']>;
  motherId: Scalars['UUID']['input'];
};

export type EditCompanyEnableDeleteReportsInput = {
  deleteReportsMonthInterval?: InputMaybe<Scalars['GraphQLDeleteReportsMonthInterval']['input']>;
  enableDeleteReports: Scalars['Boolean']['input'];
  motherId: Scalars['UUID']['input'];
};

export type EditCompanyOpenIdInput = {
  motherId: Scalars['UUID']['input'];
  openIdClientId: Scalars['GraphQLString']['input'];
  openIdClientSecret: Scalars['GraphQLString']['input'];
  openIdProviderUrl: Scalars['GraphQLString']['input'];
};

export type EditCompanyReportAssignedMembersInput = {
  caseId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  newAssignedMembers?: InputMaybe<Array<ReportAssignedMember>>;
};

export type EditCompanyReportCategoryInput = {
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  language: Language;
  name: Scalars['GraphQLShortString']['input'];
};

export type EditCompanyReportDeadlineDoneInput = {
  caseId: Scalars['UUID']['input'];
  deadlineDone: Scalars['Boolean']['input'];
};

export type EditCompanyReportDeadlineInput = {
  caseId: Scalars['UUID']['input'];
  newDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EditCompanyReportInput = {
  answers: Array<EditAnswerInput>;
  /** Newly uploaded More information files, appended to the ones the case already has */
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Already uploaded More information files that should be removed */
  attachmentsToDelete?: InputMaybe<Array<Scalars['AttachmentGlobalId']['input']>>;
  caseId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  newBody?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  newBodyNonce?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  newCategoryId?: InputMaybe<Scalars['CompanyReportCategoryGlobalId']['input']>;
  newCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  newCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  newSource?: InputMaybe<CaseSourceType>;
  recipients: Array<ReportAssignedMember>;
};

export type EditCompanyReportInternalCommentInput = {
  /** attachments stream */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  attachmentsToDelete?: InputMaybe<Array<Scalars['AttachmentGlobalId']['input']>>;
  ciphertext: Scalars['Base64UrlSafe']['input'];
  commentId: Scalars['CompanyReportInternalCommentGlobalId']['input'];
  mentionedMemberIds: Array<Scalars['UUID']['input']>;
  motherId: Scalars['UUID']['input'];
  nonce: Scalars['Base64UrlSafe']['input'];
  recipientKeys: Array<MemberReportKeys>;
};

export type EditCompanyReportMemberAccessInput = {
  caseId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  newAccessMembers?: InputMaybe<Array<ReportAssignedMember>>;
};

export type EditCompanyReportNameVisibilityInput = {
  caseId: Scalars['UUID']['input'];
};

export type EditCompanyReportPriorityInput = {
  caseId: Scalars['UUID']['input'];
  newPriority?: InputMaybe<CasePriority>;
};

export type EditCompanyReportStatusInput = {
  caseId: Scalars['UUID']['input'];
  closingReasonId?: InputMaybe<Scalars['UUID']['input']>;
  newStatusId: Scalars['UUID']['input'];
  reportClosingComment: ReportClosingType;
};

export type EditCompanyReportViewInput = {
  caseId: Scalars['UUID']['input'];
};

export type EditCompanyRipplingSSOInput = {
  motherId: Scalars['UUID']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type EditCompanyWorkingHoursInput = {
  companyId: Scalars['UUID']['input'];
  days: Array<WorkingHoursDayInput>;
  outsideWorkingHoursMessage: Scalars['GraphQLMediumString']['input'];
  timezone: Scalars['GraphQLString']['input'];
};

export type EditConfigBrandingInput = {
  configId: Scalars['UUID']['input'];
  isBrandingHidden: Scalars['Boolean']['input'];
};

export type EditConfigColorsInput = {
  configId: Scalars['UUID']['input'];
  darkColor?: InputMaybe<Scalars['Color']['input']>;
  primaryColor?: InputMaybe<Scalars['Color']['input']>;
};

export type EditConfigLogoInput = {
  configId: Scalars['UUID']['input'];
  /** Image stream */
  image?: InputMaybe<Scalars['Upload']['input']>;
  logoType: LogoType;
};

export type EditEmailCompanyVictimAnonymousInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  identity: Scalars['GraphQLString']['input'];
  organizationalUnitId: Scalars['UUID']['input'];
  passwordPrehash: Scalars['GraphQLString']['input'];
  reportPassword?: InputMaybe<Scalars['GraphQLString']['input']>;
  version: Scalars['EncryptionVersion']['input'];
};

export type EditEmailCompanyVictimInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
};

export type EditEmployeeInput = {
  employeeFields: EmployeeAttributesInput;
  employeeId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
};

export type EditEmployeeStatusInput = {
  employeeId: Scalars['UUID']['input'];
  newStatus: EmployeeStatus;
};

export type EditFormAnonymityPreselectInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  newAnonymityPreselect: Scalars['Boolean']['input'];
};

export type EditFormItemInput = {
  addToCategoriesIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  language: Language;
};

export type EditFormItemOptionInput = {
  id?: InputMaybe<Scalars['FormItemOptionGlobalId']['input']>;
  label: Scalars['GraphQLMediumString']['input'];
  order: Scalars['Int']['input'];
};

export type EditInstitutionNameInput = {
  institutionName: Scalars['GraphQLShortString']['input'];
  language: Language;
  motherId: Scalars['UUID']['input'];
};

export type EditIsVerifiedCompanyVictimInput = {
  token: Scalars['GraphQLString']['input'];
};

export type EditMemberInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  memberId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  name: Scalars['AllowedUserName']['input'];
  organizationalUnitIds: Array<Scalars['UUID']['input']>;
  permissions: Array<PermissionInput>;
  phone?: InputMaybe<Scalars['Phone']['input']>;
};

export type EditMemberNotificationInput = {
  enabled: Scalars['Boolean']['input'];
  notificationId: Scalars['MemberNotificationGlobalId']['input'];
  scope: NotificationScope;
};

export type EditOnboardingInformationInput = {
  motherId: Scalars['UUID']['input'];
  role?: InputMaybe<Role>;
  useCase?: InputMaybe<UseCase>;
};

export type EditOrganizationalUnitInput = {
  organizationalUnitId: Scalars['UUID']['input'];
  organizationalUnitName: Scalars['GraphQLShortString']['input'];
};

export type EditPageInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  content?: InputMaybe<Scalars['GraphQLText']['input']>;
  icon?: InputMaybe<Scalars['GraphQLString']['input']>;
  language: Language;
  pageId: Scalars['UUID']['input'];
  title?: InputMaybe<Scalars['GraphQLShortString']['input']>;
};

export type EditPartnerChannelAfterSendInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  emailNotificationEnabled: Scalars['Boolean']['input'];
  language: Language;
  reportSentDescription: Scalars['GraphQLMediumString']['input'];
};

export type EditPartnerChannelAnonymityInput = {
  anonymityEnabled: Scalars['Boolean']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
};

export type EditPartnerChannelBeforeSendInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  recipientsOnReportForm: RecipientsOnReportForm;
};

export type EditPartnerFormItemInput = {
  addToCategoriesIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  language: Language;
};

export type EditPartnerLanguageInput = {
  language: Language;
};

export type EditPartnerReportCategoryInput = {
  categoryId: Scalars['CompanyReportCategoryGlobalId']['input'];
  configId: Scalars['UUID']['input'];
  language: Language;
  name: Scalars['GraphQLShortString']['input'];
};

export type EditPartnerTwoFactorAuthenticationInput = {
  secret?: InputMaybe<Scalars['GraphQLString']['input']>;
  token?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type EditReportJustificationInput = {
  caseId: Scalars['UUID']['input'];
  justification: CaseJustification;
};

export type EditScaleFormItemInput = {
  addToCategoriesIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  end: NewScaleFormItemOption;
  formItemId: Scalars['FormItemGlobalId']['input'];
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired: Scalars['Boolean']['input'];
  label: Scalars['GraphQLMediumString']['input'];
  start: NewScaleFormItemOption;
};

export type EditSelectFormItemInput = {
  addToCategoriesIds: Array<Scalars['CompanyReportCategoryGlobalId']['input']>;
  channelId: Scalars['ReportSourceGlobalId']['input'];
  formItemId: Scalars['FormItemGlobalId']['input'];
  hasOtherOption?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  isRequired: Scalars['Boolean']['input'];
  label: Scalars['GraphQLMediumString']['input'];
  options: Array<EditFormItemOptionInput>;
};

export type EditSelfUserInput = {
  bio?: InputMaybe<Scalars['GraphQLShortString']['input']>;
  email: Scalars['Email']['input'];
  language: Language;
  name: Scalars['AllowedUserName']['input'];
  phone: Scalars['GraphQLString']['input'];
  role: Role;
  useCase: UseCase;
};

export type EditSnippetInput = {
  content: Scalars['GraphQLMediumString']['input'];
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
  shortcut: Scalars['GraphQLShortString']['input'];
  snippetId: Scalars['UUID']['input'];
};

export type EditSurveyAfterSendInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  description?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  title?: InputMaybe<Scalars['GraphQLShortString']['input']>;
};

export type EditSurveyBeforeSendInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  description?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  title?: InputMaybe<Scalars['GraphQLShortString']['input']>;
};

export type EditSurveyLanguageInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  newLanguage: Language;
};

export type EditSurveyLogoInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  /** Logo stream */
  logo?: InputMaybe<Scalars['Upload']['input']>;
};

export type EditSurveyNameInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type EditTwoFactorAuthenticationInput = {
  /** Pass the mother ID because the tenant permission check requires it. */
  motherId: Scalars['UUID']['input'];
  secret?: InputMaybe<Scalars['GraphQLString']['input']>;
  token?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type EditUserImageInput = {
  /** Image stream */
  image: Scalars['Upload']['input'];
};

export type EditUserPasswordInput = {
  currentPasswordPrehash: Scalars['GraphQLString']['input'];
  isMigration?: InputMaybe<Scalars['Boolean']['input']>;
  newNonce: Scalars['Base64UrlSafe']['input'];
  newPasswordPrehash: Scalars['GraphQLString']['input'];
  newPrivateKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  newSalt: Scalars['Base64UrlSafe']['input'];
  privateKeyRecovery?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  privateKeyRecoveryNonce?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  recoveryKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  recoveryKeyEncryptedNonce: Scalars['Base64UrlSafe']['input'];
  systemRecoveryKey?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
};

export type EditWebhookInput = {
  name: Scalars['GraphQLString']['input'];
  types: Array<WebhookType>;
  url: Scalars['Url']['input'];
  webhookId: Scalars['UUID']['input'];
};

export type EmployeeAttributesInput = {
  department?: InputMaybe<Scalars['GraphQLShortString']['input']>;
  email: Scalars['Email']['input'];
  jobTitle?: InputMaybe<Scalars['GraphQLShortString']['input']>;
  location?: InputMaybe<Scalars['GraphQLShortString']['input']>;
  name: Scalars['GraphQLShortString']['input'];
  status: EmployeeStatus;
  supervisor?: InputMaybe<Scalars['GraphQLShortString']['input']>;
};

export type EmployeeFiltersInput = {
  /** If true, only returns employees with active status */
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search term for all employee's attributes (including name, email, location, department, etc.) */
  fullSearch?: InputMaybe<Scalars['GraphQLString']['input']>;
  /** Search term for employee's name or email */
  nameOrEmailSearch?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export enum EmployeeInvolvement {
  Involved = 'Involved',
  Reporter = 'Reporter',
  Witness = 'Witness'
}

export enum EmployeeProvider {
  ApiSync = 'ApiSync',
  BambooHr = 'BambooHr',
  Deel = 'Deel',
  Manual = 'Manual',
  Paylocity = 'Paylocity',
  Rippling = 'Rippling',
  UkgPro = 'UkgPro',
  UkgReady = 'UkgReady'
}

export enum EmployeeStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type EmployeesWithSelectAllOption = {
  ids: Array<Scalars['UUID']['input']>;
  variant: Variant;
};

export type EnhanceReportCommentInput = {
  message: Scalars['GraphQLString']['input'];
  type: MessageAction;
};

export type ExchangeCognitoCodeForTokenInput = {
  code: Scalars['GraphQLString']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type ExcludeOrganizationalUnitsFromAnonymityInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  organizationalUnitIds: Array<Scalars['UUID']['input']>;
};

export type ExportCasesInput = {
  caseIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filter: ReportFilterInput;
  motherId: Scalars['UUID']['input'];
  sourceLanguage?: InputMaybe<Language>;
  targetLanguage?: InputMaybe<Language>;
};

export type ExportSurveyInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
  submissionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum Feature {
  AnonymousReporting = 'AnonymousReporting',
  Api = 'Api',
  CaseManagement = 'CaseManagement',
  CustomDocuments = 'CustomDocuments',
  Disclosures = 'Disclosures',
  EmployeeManagement = 'EmployeeManagement',
  Integrations = 'Integrations',
  Investigations = 'Investigations',
  IpAllowlist = 'IpAllowlist',
  NewInvestigations = 'NewInvestigations',
  ReportingForms = 'ReportingForms',
  Sso = 'Sso',
  Surveys = 'Surveys',
  TeamMembers = 'TeamMembers',
  Webhooks = 'Webhooks',
  Whitelabel = 'Whitelabel'
}

export enum FeatureType {
  Custom = 'Custom',
  Quantity = 'Quantity',
  Switch = 'Switch'
}

export type ForceDeleteCompanyInput = {
  companyId: Scalars['UUID']['input'];
  shouldForceDelete: Scalars['Boolean']['input'];
};

export type ForceDeleteCompanyOpenIdInput = {
  motherId: Scalars['UUID']['input'];
};

export type ForgottenUserPasswordInput = {
  email: Scalars['Email']['input'];
};

export enum FormItemType {
  Category = 'Category',
  Classroom = 'Classroom',
  Date = 'Date',
  Email = 'Email',
  File = 'File',
  Matrix = 'Matrix',
  MoreInformation = 'MoreInformation',
  MultiSelect = 'MultiSelect',
  MultilineText = 'MultilineText',
  Number = 'Number',
  OrganizationalUnit = 'OrganizationalUnit',
  PhoneNumber = 'PhoneNumber',
  Rating = 'Rating',
  Scale = 'Scale',
  Select = 'Select',
  SenderName = 'SenderName',
  SimpleText = 'SimpleText',
  YesNo = 'YesNo'
}

export enum FrontendPermissionType {
  Analytics = 'Analytics',
  BillingAccess = 'BillingAccess',
  DeleteCases = 'DeleteCases',
  DisclosureAccess = 'DisclosureAccess',
  EditCases = 'EditCases',
  ExportCases = 'ExportCases',
  InvestigationAccess = 'InvestigationAccess',
  ManageCategories = 'ManageCategories',
  ManageOrganizationalUnits = 'ManageOrganizationalUnits',
  ManageReportingChannels = 'ManageReportingChannels',
  ManageUsers = 'ManageUsers',
  ReportAccess = 'ReportAccess',
  SettingsAccess = 'SettingsAccess',
  Surveys = 'Surveys',
  WriteInternalComments = 'WriteInternalComments',
  WriteMessages = 'WriteMessages'
}

export enum FuAdminRoleType {
  Admin = 'Admin',
  IntegrationDeveloper = 'IntegrationDeveloper',
  Manager = 'Manager',
  Psychologist = 'Psychologist'
}

export type GetBambooHrRefreshTokenInput = {
  code: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type GetDeelOAuthUrlInput = {
  motherId: Scalars['UUID']['input'];
};

export type GetMailerLiteEmailInput = {
  previewId: Scalars['GraphQLShortString']['input'];
};

export type GetRipplingOAuthUrlInput = {
  motherId: Scalars['UUID']['input'];
};

export type GetTeamsOAuthUrlInput = {
  motherId: Scalars['UUID']['input'];
};

export type GetUkgReadyAccessTokenInput = {
  code: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type GetVantaAccessTokenInput = {
  code: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type GetVantaOAuthUrlInput = {
  motherId: Scalars['UUID']['input'];
};

export enum GlobalTable {
  DisclosureFormShortlinkDiscovery = 'DisclosureFormShortlinkDiscovery',
  EmailDiscovery = 'EmailDiscovery',
  IntegrationDiscovery = 'IntegrationDiscovery',
  InternalMaterial = 'InternalMaterial',
  PhoneDiscovery = 'PhoneDiscovery',
  ReportPasswordDiscovery = 'ReportPasswordDiscovery',
  ShortlinkDiscovery = 'ShortlinkDiscovery',
  TeamsInstallationDiscovery = 'TeamsInstallationDiscovery',
  TokenDiscovery = 'TokenDiscovery'
}

export type GrantCompanyReportAccessInput = {
  memberId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  recipientKeys: Array<GrantCompanyReportAccessRecipientKeys>;
};

export type GrantCompanyReportAccessRecipientKeys = {
  caseId: Scalars['UUID']['input'];
  value: Scalars['Base64UrlSafe']['input'];
};

export type HintTranslation = {
  language: Language;
  translation?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
};

export enum HotlineCountry {
  Ae = 'Ae',
  Ai = 'Ai',
  Ao = 'Ao',
  Ar = 'Ar',
  At = 'At',
  Au = 'Au',
  Ba = 'Ba',
  Bb = 'Bb',
  Be = 'Be',
  Bg = 'Bg',
  Bh = 'Bh',
  Bo = 'Bo',
  Br = 'Br',
  Bs = 'Bs',
  Bw = 'Bw',
  Ca = 'Ca',
  Ch = 'Ch',
  Ci = 'Ci',
  Cl = 'Cl',
  Cn = 'Cn',
  Co = 'Co',
  Cr = 'Cr',
  Cy = 'Cy',
  Cz = 'Cz',
  De = 'De',
  Dk = 'Dk',
  Dm = 'Dm',
  Do = 'Do',
  Ec = 'Ec',
  Ee = 'Ee',
  Eg = 'Eg',
  Es = 'Es',
  Fi = 'Fi',
  Fr = 'Fr',
  Gb = 'Gb',
  Gd = 'Gd',
  Ge = 'Ge',
  Gh = 'Gh',
  Gr = 'Gr',
  Gt = 'Gt',
  Hk = 'Hk',
  Hr = 'Hr',
  Hu = 'Hu',
  Id = 'Id',
  Ie = 'Ie',
  Il = 'Il',
  In = 'In',
  Is = 'Is',
  It = 'It',
  Jm = 'Jm',
  Jo = 'Jo',
  Jp = 'Jp',
  Ke = 'Ke',
  Kg = 'Kg',
  Kh = 'Kh',
  Kr = 'Kr',
  Ky = 'Ky',
  Kz = 'Kz',
  La = 'La',
  Lc = 'Lc',
  Lk = 'Lk',
  Lt = 'Lt',
  Lu = 'Lu',
  Lv = 'Lv',
  Ma = 'Ma',
  Mc = 'Mc',
  Md = 'Md',
  Me = 'Me',
  Mm = 'Mm',
  Mo = 'Mo',
  Mt = 'Mt',
  Mu = 'Mu',
  Mx = 'Mx',
  My = 'My',
  Ng = 'Ng',
  Ni = 'Ni',
  Nl = 'Nl',
  No = 'No',
  Np = 'Np',
  Nz = 'Nz',
  Om = 'Om',
  Pa = 'Pa',
  Pe = 'Pe',
  Ph = 'Ph',
  Pk = 'Pk',
  Pl = 'Pl',
  Pr = 'Pr',
  Pt = 'Pt',
  Py = 'Py',
  Qa = 'Qa',
  Ro = 'Ro',
  Rs = 'Rs',
  Ru = 'Ru',
  Sa = 'Sa',
  Se = 'Se',
  Sg = 'Sg',
  Si = 'Si',
  Sk = 'Sk',
  Sv = 'Sv',
  Th = 'Th',
  Tn = 'Tn',
  Tr = 'Tr',
  Tt = 'Tt',
  Tw = 'Tw',
  Tz = 'Tz',
  Ua = 'Ua',
  Ug = 'Ug',
  Us = 'Us',
  Uy = 'Uy',
  Ve = 'Ve',
  Vg = 'Vg',
  Vn = 'Vn',
  Za = 'Za'
}

export enum HotlineLanguage {
  Af = 'Af',
  Ar = 'Ar',
  Bg = 'Bg',
  Bn = 'Bn',
  Ca = 'Ca',
  Cs = 'Cs',
  Cy = 'Cy',
  Da = 'Da',
  De = 'De',
  El = 'El',
  En_Gb = 'En_Gb',
  En_Us = 'En_Us',
  Es = 'Es',
  Es_Mx = 'Es_Mx',
  Eu = 'Eu',
  Fi = 'Fi',
  Fr = 'Fr',
  Fr_Ca = 'Fr_Ca',
  Gl = 'Gl',
  Gu = 'Gu',
  He = 'He',
  Hi = 'Hi',
  Hu = 'Hu',
  Id = 'Id',
  Is = 'Is',
  It = 'It',
  Ja = 'Ja',
  Kn = 'Kn',
  Ko = 'Ko',
  Lt = 'Lt',
  Lv = 'Lv',
  Ml = 'Ml',
  Mr = 'Mr',
  Ms = 'Ms',
  Nb = 'Nb',
  Nl = 'Nl',
  Pa = 'Pa',
  Pl = 'Pl',
  Pt = 'Pt',
  Pt_Pt = 'Pt_Pt',
  Ro = 'Ro',
  Ru = 'Ru',
  Sk = 'Sk',
  Sr = 'Sr',
  Sv = 'Sv',
  Ta = 'Ta',
  Te = 'Te',
  Th = 'Th',
  Tl = 'Tl',
  Tr = 'Tr',
  Uk = 'Uk',
  Vi = 'Vi',
  Zh = 'Zh',
  Zh_Tw = 'Zh_Tw'
}

export enum HotlineOrderStatus {
  Completed = 'Completed',
  Processing = 'Processing'
}

export enum HotlinePhoneNumberType {
  Landline = 'Landline',
  TollFree = 'TollFree'
}

export type HotlinesFiltersInput = {
  country?: InputMaybe<Country>;
  hotlineType?: InputMaybe<ChannelType>;
  institutionName?: InputMaybe<Scalars['GraphQLString']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderStatus?: InputMaybe<HotlineOrderStatus>;
  phoneNumberType?: InputMaybe<HotlinePhoneNumberType>;
  subscriptionStatus?: InputMaybe<ChargebeeSubscriptionStatus>;
};

export type HotlinesOrderBy = {
  key: HotlinesOrderByPossibleKeys;
  order: OrderByKeyword;
};

export enum HotlinesOrderByPossibleKeys {
  country = 'country',
  hotlineName = 'hotlineName',
  hotlineType = 'hotlineType',
  institutionName = 'institutionName',
  isEnabled = 'isEnabled',
  languages = 'languages',
  orderStatus = 'orderStatus',
  phoneNumber = 'phoneNumber',
  phoneNumberType = 'phoneNumberType',
  subscriptionStatus = 'subscriptionStatus'
}

export type ImportReportsInput = {
  motherId: Scalars['UUID']['input'];
  /** Compressed with json reports */
  reports: Scalars['JSON']['input'];
};

export enum Institution {
  Company = 'Company',
  School = 'School'
}

export enum IntegrationKey {
  bambooHr = 'bambooHr',
  deel = 'deel',
  make = 'make',
  paylocity = 'paylocity',
  powerBi = 'powerBi',
  rippling = 'rippling',
  slack = 'slack',
  teams = 'teams',
  ukgPro = 'ukgPro',
  ukgReady = 'ukgReady',
  vanta = 'vanta',
  zapier = 'zapier'
}

export type InternalMessageInput = {
  /** attachments stream */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  ciphertext: Scalars['Base64UrlSafe']['input'];
  nonce: Scalars['Base64UrlSafe']['input'];
  originalCommentId: Scalars['CompanyReportInternalCommentGlobalId']['input'];
};

export enum InvestigationStatus {
  Closed = 'Closed',
  New = 'New',
  Open = 'Open'
}

export enum InvestigationStatusFilter {
  Closed = 'Closed',
  New = 'New',
  None = 'None',
  Open = 'Open'
}

export enum InvitationStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Sent = 'Sent'
}

export enum InvoicedTo {
  Client = 'Client',
  Partner = 'Partner'
}

export type LabelTranslation = {
  language: Language;
  translation?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
};

export enum Language {
  Af = 'Af',
  Am = 'Am',
  Ar = 'Ar',
  Az = 'Az',
  Be = 'Be',
  Bg = 'Bg',
  Bn = 'Bn',
  Bs = 'Bs',
  Ca = 'Ca',
  Ceb = 'Ceb',
  Co = 'Co',
  Cs = 'Cs',
  Cy = 'Cy',
  Da = 'Da',
  De = 'De',
  El = 'El',
  En_Gb = 'En_Gb',
  En_Us = 'En_Us',
  Es = 'Es',
  Es_Mx = 'Es_Mx',
  Et = 'Et',
  Eu = 'Eu',
  Fa = 'Fa',
  Fa_Af = 'Fa_Af',
  Fi = 'Fi',
  Fr = 'Fr',
  Fr_Ca = 'Fr_Ca',
  Fy_Nl = 'Fy_Nl',
  Ga = 'Ga',
  Gd = 'Gd',
  Gl = 'Gl',
  Gu = 'Gu',
  Ha = 'Ha',
  Haw = 'Haw',
  He = 'He',
  Hi = 'Hi',
  Hmn = 'Hmn',
  Hr = 'Hr',
  Ht = 'Ht',
  Hu = 'Hu',
  Hy = 'Hy',
  Id = 'Id',
  Ig = 'Ig',
  Is = 'Is',
  It = 'It',
  Ja = 'Ja',
  Jv = 'Jv',
  Ka = 'Ka',
  Kk = 'Kk',
  Km = 'Km',
  Kn = 'Kn',
  Ko = 'Ko',
  Ku = 'Ku',
  Ky = 'Ky',
  Lb = 'Lb',
  Lo = 'Lo',
  Lt = 'Lt',
  Lv = 'Lv',
  Mg = 'Mg',
  Mi = 'Mi',
  Mk = 'Mk',
  Ml = 'Ml',
  Mn = 'Mn',
  Mr = 'Mr',
  Ms = 'Ms',
  Mt = 'Mt',
  My_Mm = 'My_Mm',
  Nb = 'Nb',
  Ne = 'Ne',
  Nl = 'Nl',
  Ny = 'Ny',
  Or = 'Or',
  Pa = 'Pa',
  Pl = 'Pl',
  Ps = 'Ps',
  Pt = 'Pt',
  Pt_Pt = 'Pt_Pt',
  Ro = 'Ro',
  Ru = 'Ru',
  Rw = 'Rw',
  Sd = 'Sd',
  Si = 'Si',
  Sk = 'Sk',
  Sl = 'Sl',
  Sm = 'Sm',
  Sn = 'Sn',
  So = 'So',
  Sq = 'Sq',
  Sr = 'Sr',
  St = 'St',
  Su = 'Su',
  Sv = 'Sv',
  Sw = 'Sw',
  Ta = 'Ta',
  Te = 'Te',
  Tg = 'Tg',
  Th = 'Th',
  Tk = 'Tk',
  Tl = 'Tl',
  Tr = 'Tr',
  Tt = 'Tt',
  Ug = 'Ug',
  Uk = 'Uk',
  Ur = 'Ur',
  Uz = 'Uz',
  Vi = 'Vi',
  Xh = 'Xh',
  Yi = 'Yi',
  Yo = 'Yo',
  Zh = 'Zh',
  Zh_Tw = 'Zh_Tw',
  Zu = 'Zu'
}

export enum LegacyInvestigationStatus {
  Closed = 'Closed',
  InProgress = 'InProgress'
}

export type LinkCasesInput = {
  caseId: Scalars['UUID']['input'];
  linkedCaseIds: Array<Scalars['UUID']['input']>;
};

export type LinkCompanyToPartnerInput = {
  motherId: Scalars['UUID']['input'];
  partnerId: Scalars['UUID']['input'];
};

export enum LogoSize {
  lg = 'lg',
  md = 'md',
  xl = 'xl'
}

export enum LogoType {
  Rectangular = 'Rectangular',
  Square = 'Square'
}

export type MarkAsReadCompanyFollowUpCommentsByMemberInput = {
  caseId: Scalars['UUID']['input'];
  commentId: Scalars['CompanyReportFollowUpCommentGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
};

export type MarkAsReadCompanyFollowUpCommentsByVictimInput = {
  caseId: Scalars['UUID']['input'];
  commentId: Scalars['CompanyReportFollowUpCommentGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
};

export type MarkAsReadCompanyInternalCommentsInput = {
  caseId: Scalars['UUID']['input'];
  commentId: Scalars['CompanyReportInternalCommentGlobalId']['input'];
  motherId: Scalars['UUID']['input'];
};

export enum MaterialGenerationType {
  Certificate = 'Certificate',
  Leaflet = 'Leaflet',
  Static = 'Static'
}

export enum MaterialType {
  Guide = 'Guide',
  Other = 'Other',
  Promotion = 'Promotion',
  Template = 'Template'
}

export type MatrixValuesInput = {
  optionId: Scalars['UUID']['input'];
  questionId: Scalars['UUID']['input'];
};

export type MemberReportKeys = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  key: Scalars['Base64UrlSafe']['input'];
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MessageAction {
  ExpandMessage = 'ExpandMessage',
  RewriteFriendly = 'RewriteFriendly',
  RewriteProfessional = 'RewriteProfessional',
  SpellCheck = 'SpellCheck'
}

export type MigrateToSSOInput = {
  privateKey: Scalars['Base64UrlSafe']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type MigrateVictimEncryptionInput = {
  currentPasswordPrehash: Scalars['GraphQLString']['input'];
  newNonce: Scalars['Base64UrlSafe']['input'];
  newPasswordPrehash: Scalars['GraphQLString']['input'];
  newPrivateKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  newSalt: Scalars['Base64UrlSafe']['input'];
};

export type NewClosingCommentNonce = {
  body?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  nonce?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
};

export type NewCompanyReportActivityInput = {
  caseId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NewCompanyReportAuditLogInput = {
  caseId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NewFormItemOptionInput = {
  label: Scalars['GraphQLMediumString']['input'];
  order: Scalars['Int']['input'];
};

export type NewPageOrderType = {
  id: Scalars['UUID']['input'];
  order: Scalars['Int']['input'];
};

export type NewScaleFormItemOption = {
  label?: InputMaybe<Scalars['GraphQLMediumString']['input']>;
  value: Scalars['Int']['input'];
};

export enum NotificationScope {
  All = 'All',
  OnlyAssignedReports = 'OnlyAssignedReports'
}

export enum NotificationType {
  Investigations = 'Investigations',
  NewFollowUpCommentForAssignedReport = 'NewFollowUpCommentForAssignedReport',
  NewFollowUpCommentForUnassignedReport = 'NewFollowUpCommentForUnassignedReport',
  NewInternalCommentMention = 'NewInternalCommentMention',
  NewReport = 'NewReport',
  ReportAssignedToMe = 'ReportAssignedToMe',
  ReportNearDeadline = 'ReportNearDeadline'
}

export type OpenaiWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['String']['input'];
};

export type OptionTranslation = {
  language: Language;
  translation: Scalars['GraphQLMediumString']['input'];
};

export type OptionTranslations = {
  id: Scalars['FormItemOptionGlobalId']['input'];
  translations: Array<OptionTranslation>;
};

export type OrderByCompanies = {
  key: OrderByCompaniesPossibleKeys;
  order: OrderByKeyword;
};

export enum OrderByCompaniesPossibleKeys {
  CountOfReports = 'CountOfReports'
}

export type OrderByCompanyReports = {
  key: OrderByCompanyReportsPossibleKeys;
  order: OrderByKeyword;
};

export enum OrderByCompanyReportsPossibleKeys {
  category = 'category',
  deadline = 'deadline',
  manually_created_at = 'manually_created_at',
  priority = 'priority',
  source = 'source',
  status = 'status',
  updated_at = 'updated_at'
}

export enum OrderByKeyword {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OrderCompanyReportCategoryInput = {
  categories: Array<CompanyReportCategoryOrderType>;
  motherId: Scalars['UUID']['input'];
};

export type OrderPartnerReportCategoryInput = {
  categories: Array<InputMaybe<PartnerReportCategoryOrderType>>;
  configId: Scalars['UUID']['input'];
};

export type PartnerReportCategoryOrderType = {
  id: Scalars['CompanyReportCategoryGlobalId']['input'];
  order: Scalars['Int']['input'];
};

export type PaylocityWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['GraphQLString']['input'];
};

export enum PaymentMethod {
  CreditCard = 'CreditCard',
  Invoice = 'Invoice'
}

export type PermissionAdditionalDataInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['CompanyReportCategoryGlobalId']['input']>>>;
};

export type PermissionInput = {
  additionalData?: InputMaybe<PermissionAdditionalDataInput>;
  enabled: Scalars['Boolean']['input'];
  type: FrontendPermissionType;
};

export enum PhoneNumberStatus {
  DatabaseOnly = 'DatabaseOnly',
  Everywhere = 'Everywhere',
  MissingFromDatabase = 'MissingFromDatabase',
  MissingFromPhoneDiscovery = 'MissingFromPhoneDiscovery',
  MissingFromVonage = 'MissingFromVonage',
  Nowhere = 'Nowhere',
  PhoneDiscoveryOnly = 'PhoneDiscoveryOnly',
  VonageOnly = 'VonageOnly'
}

export enum Plan {
  Basic = 'Basic',
  Free = 'Free',
  Platform = 'Platform',
  Premium = 'Premium',
  Standard = 'Standard',
  Unregistered = 'Unregistered'
}

export type ProlongTrialInput = {
  motherId: Scalars['UUID']['input'];
};

export enum RecaptchaType {
  Checkbox = 'Checkbox',
  Invisible = 'Invisible'
}

export enum RecipientsOnReportForm {
  Editable = 'Editable',
  Invisible = 'Invisible',
  Visible = 'Visible'
}

export type RedactedUserInput = {
  id: Scalars['ID']['input'];
};

export type RegisterClientInstitutionInput = {
  clientEmail: Scalars['Email']['input'];
  currency: Currency;
  institution: RegisterInstitution;
  invoicedTo: InvoicedTo;
  plan: Plan;
  shouldImportPartnerConfig: Scalars['Boolean']['input'];
};

export type RegisterCrypto = {
  nonce: Scalars['Base64UrlSafe']['input'];
  passwordPrehash: Scalars['Base64UrlSafe']['input'];
  privateKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  privateKeyRecovery?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  privateKeyRecoveryNonce?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  publicKey: Scalars['Base64UrlSafe']['input'];
  recoveryKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  recoveryKeyEncryptedNonce: Scalars['Base64UrlSafe']['input'];
  recoveryKeySystemEncrypted: Scalars['Base64UrlSafe']['input'];
  salt: Scalars['Base64UrlSafe']['input'];
};

export type RegisterInstitution = {
  country: Country;
  language: Language;
  organizationalUnitName: Scalars['GraphQLShortString']['input'];
  timezone: Scalars['GraphQLString']['input'];
};

export type RegisterInstitutionInput = {
  crypto: RegisterCrypto;
  institution: RegisterInstitution;
  isNewPricing?: InputMaybe<Scalars['Boolean']['input']>;
  isPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  user: RegisterUser;
};

export type RegisterUser = {
  name: Scalars['AllowedUserName']['input'];
  phone: Scalars['GraphQLString']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type RejectPartnerRegistrationInput = {
  partnerId: Scalars['UUID']['input'];
};

export type RejectSchoolRegistrationInput = {
  organizationalUnitId: Scalars['UUID']['input'];
};

export type RemovePartnerUserInput = {
  memberId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
};

export type ReportAssignedMember = {
  id: Scalars['UUID']['input'];
  recipientKey: Scalars['Base64UrlSafe']['input'];
};

export type ReportClosingType = {
  newClosingComment?: InputMaybe<NewClosingCommentNonce>;
};

export type ReportFilterInput = {
  caseStatusGroup?: InputMaybe<Array<CaseStatusGroup>>;
  categoryIds?: InputMaybe<Array<Scalars['CompanyReportCategoryGlobalId']['input']>>;
  closingReasonIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  creationOrigins?: InputMaybe<Array<CaseCreationOrigin>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  deadline?: InputMaybe<CaseDeadlineFilter>;
  employeeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  hiddenFromStatistics?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  investigationStatusFilter?: InputMaybe<Array<InvestigationStatusFilter>>;
  justifications?: InputMaybe<Array<CaseJustification>>;
  labelIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  linkedCaseIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  memberIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  onlyAccessibleWithKey?: InputMaybe<Scalars['Boolean']['input']>;
  priorities?: InputMaybe<Array<CasePriority>>;
  ratings?: InputMaybe<Array<Scalars['GraphQLCaseRating']['input']>>;
  reportSourceIds?: InputMaybe<Array<Scalars['ReportSourceGlobalId']['input']>>;
  sources?: InputMaybe<Array<CaseSourceType>>;
  statusIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tag?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type RequestCompanyReportAccessInput = {
  motherId: Scalars['UUID']['input'];
};

export type RequestLiveHotlineOrderInput = {
  country: Country;
  language: Language;
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLString']['input'];
};

export type RequestNewIntegrationInput = {
  description: Scalars['GraphQLMediumString']['input'];
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLShortString']['input'];
};

export type RequestPartnerRegistrationInput = {
  crypto: RegisterCrypto;
  institution: RegisterInstitution;
  user: RegisterUser;
};

export type RequestPaylocityInput = {
  motherId: Scalars['UUID']['input'];
};

export type RequestSchoolRegistrationInput = {
  companyId: Scalars['UUID']['input'];
  crypto: RegisterCrypto;
  isPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  user: RegisterUser;
};

export type ResendMemberInvitationInput = {
  memberId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
};

export type ResendPartnerInvitationInput = {
  partnerMemberId: Scalars['UUID']['input'];
};

export enum ResendVictimEmailVerificationResult {
  AlreadyVerified = 'AlreadyVerified',
  NoEmailSet = 'NoEmailSet',
  RateLimited = 'RateLimited',
  Success = 'Success'
}

export type ResetDeleteReportsIntervalInput = {
  motherId: Scalars['UUID']['input'];
};

export type RipplingOauthCodeExchangeInput = {
  code: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  state?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type RipplingSSOAccessTokenInput = {
  token: Scalars['GraphQLString']['input'];
};

export type RipplingSSOCodeExchangeInput = {
  code: Scalars['GraphQLString']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type RipplingWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['GraphQLString']['input'];
};

export enum Role {
  Advisor = 'Advisor',
  Analyst = 'Analyst',
  Counsel = 'Counsel',
  Executive = 'Executive',
  Hr = 'Hr',
  Investigator = 'Investigator',
  Lead = 'Lead',
  Officer = 'Officer',
  Other = 'Other',
  Partner = 'Partner',
  Psychologist = 'Psychologist',
  Specialist = 'Specialist'
}

export type SaveInvestigationStep1Input = {
  caseId: Scalars['UUID']['input'];
  investigationId: Scalars['UUID']['input'];
  investigatorId?: InputMaybe<Scalars['UUID']['input']>;
  involvedEmployeeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  motherId: Scalars['UUID']['input'];
  reporterEmployeeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  witnessEmployeeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type SaveInvestigationStep2Input = {
  howItHappened?: InputMaybe<Scalars['GraphQLString']['input']>;
  incidentDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  investigationId: Scalars['UUID']['input'];
  whatWasReported?: InputMaybe<Scalars['GraphQLString']['input']>;
  whereItHappened?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type SaveInvestigationStep3Input = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  investigationId: Scalars['UUID']['input'];
  outcome?: InputMaybe<Scalars['GraphQLString']['input']>;
  recommendations?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type SendCancelSubscriptionRequestInput = {
  motherId: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type SendCompanyOpenIdUpdateEmailInput = {
  motherId: Scalars['UUID']['input'];
};

export type SendMailerLiteEmailsInput = {
  fromEmailPrefix: Scalars['GraphQLShortString']['input'];
  fromName: Scalars['GraphQLShortString']['input'];
  html: Scalars['GraphQLString']['input'];
  shouldSynchronizeAllRegions: Scalars['Boolean']['input'];
  subject: Scalars['GraphQLShortString']['input'];
};

export type SendMailerLiteTestEmailInput = {
  fromEmailPrefix: Scalars['GraphQLShortString']['input'];
  fromName: Scalars['GraphQLShortString']['input'];
  html: Scalars['GraphQLString']['input'];
  subject: Scalars['GraphQLShortString']['input'];
  toEmailPrefix: Scalars['GraphQLShortString']['input'];
};

export type SendReportEmailsInput = {
  caseId: Scalars['UUID']['input'];
  /** Email addresses to send to the school if not registered */
  emailsForUnregisteredInstitution?: InputMaybe<Array<Scalars['Email']['input']>>;
};

export type SendUnregisteredSchoolTipInput = {
  schoolName: Scalars['GraphQLShortString']['input'];
};

export type SetDeleteReportsIntervalInput = {
  motherId: Scalars['UUID']['input'];
};

export type SetUpcomingIntegrationNotificationInput = {
  integration: IntegrationKey;
  motherId: Scalars['UUID']['input'];
  notify: Scalars['Boolean']['input'];
};

export type SetupPaylocityInput = {
  motherId: Scalars['UUID']['input'];
  paylocityCompanyId: Scalars['GraphQLString']['input'];
};

export type ShareSurveyByEmailInput = {
  buttonText: Scalars['GraphQLShortString']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
  employees: EmployeesWithSelectAllOption;
  fromName: Scalars['GraphQLShortString']['input'];
  motherId: Scalars['UUID']['input'];
};

export enum SignUpClientType {
  Company = 'Company',
  Partner = 'Partner',
  School = 'School'
}

export type SlackWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type StartInvestigationInput = {
  caseId: Scalars['UUID']['input'];
};

export enum SurveySource {
  Direct = 'Direct',
  Email = 'Email',
  Qr = 'Qr',
  Unknown = 'Unknown'
}

export type SurveySubmissionsFilterInput = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includeHiddenAndDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SyncEmployeesInput = {
  employees: Array<EmployeeAttributesInput>;
};

export type SynchronizeBambooHrInput = {
  motherId: Scalars['UUID']['input'];
};

export type SynchronizeDeelInput = {
  motherId: Scalars['UUID']['input'];
};

export type SynchronizeEmployeesInput = {
  token: Scalars['GraphQLString']['input'];
};

export type SynchronizeMembersToVantaInput = {
  token: Scalars['GraphQLString']['input'];
};

export type SynchronizePaylocityInput = {
  motherId: Scalars['UUID']['input'];
};

export type SynchronizeRipplingInput = {
  motherId: Scalars['UUID']['input'];
};

export type SynchronizeSchoolDiscoveryInput = {
  activeReportPassword: Scalars['Boolean']['input'];
  address: Scalars['GraphQLString']['input'];
  country: Country;
  defaultFormId: Scalars['ReportSourceGlobalId']['input'];
  institutionId: Scalars['UUID']['input'];
  institutionName: Scalars['GraphQLString']['input'];
  isRegistered: Scalars['Boolean']['input'];
  isTesting: Scalars['Boolean']['input'];
  region: Scalars['GraphQLString']['input'];
  shouldDelete: Scalars['Boolean']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type SynchronizeUkgProInput = {
  motherId: Scalars['UUID']['input'];
};

export type TeamsWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type ToggleChannelAttachmentsInput = {
  attachmentsEnabled: Scalars['Boolean']['input'];
  channelId: Scalars['ReportSourceGlobalId']['input'];
};

export type ToggleChannelEnabledInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  isEnabled: Scalars['Boolean']['input'];
  motherId: Scalars['UUID']['input'];
};

export type ToggleChannelVoiceSubmissionInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  voiceSubmissionEnabled: Scalars['Boolean']['input'];
};

export type ToggleClosingReasonActivationInput = {
  closingReasonId: Scalars['UUID']['input'];
};

export type ToggleCompanyE2EEInput = {
  motherId: Scalars['UUID']['input'];
  newState: Scalars['Boolean']['input'];
  systemRecoveryKey?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
};

export type ToggleCompanyReportLabelInput = {
  caseId: Scalars['UUID']['input'];
  labelId: Scalars['UUID']['input'];
};

export type ToggleIntrowEnabledInput = {
  isEnabled: Scalars['Boolean']['input'];
  memberId: Scalars['UUID']['input'];
};

export type ToggleMemberSlackNotificationsInput = {
  email?: InputMaybe<Scalars['Email']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  motherId: Scalars['UUID']['input'];
};

export type ToggleMemberTeamsNotificationsInput = {
  isEnabled: Scalars['Boolean']['input'];
  motherId: Scalars['UUID']['input'];
};

export type ToggleOffWorkingHoursInput = {
  organizationalUnitId: Scalars['UUID']['input'];
};

export type TogglePartnerMaterialInput = {
  /** False if the material should be shown, true if it should be hidden */
  hide: Scalars['Boolean']['input'];
  partnerId: Scalars['UUID']['input'];
  s3Key: Scalars['GraphQLString']['input'];
};

export type TogglePartnerMaterialTypeInput = {
  /** False if the material should be shown, true if it should be hidden */
  hide: Scalars['Boolean']['input'];
  institutionType: Institution;
  language: Language;
  materialType: MaterialType;
  partnerId: Scalars['UUID']['input'];
};

export type ToggleSurveyActivationInput = {
  channelId: Scalars['ReportSourceGlobalId']['input'];
  status: ChannelStatus;
};

export type ToggleSurveySubmissionVisibilityInput = {
  isHidden: Scalars['Boolean']['input'];
  submissionId: Scalars['ID']['input'];
};

export enum TokenType {
  CreatePassword = 'CreatePassword',
  ForgottenPassword = 'ForgottenPassword',
  MigrateFromSSO = 'MigrateFromSSO',
  MigrateToSSO = 'MigrateToSSO',
  UpdateInstitutionOpenId = 'UpdateInstitutionOpenId',
  VerifyPurchaseEmail = 'VerifyPurchaseEmail',
  VerifyTrialEmail = 'VerifyTrialEmail',
  VerifyVictimEmail = 'VerifyVictimEmail'
}

export type TopUpHotlineCreditsInput = {
  /** Top-up amount in the billing currency in cents. */
  amount: Scalars['Int']['input'];
  motherId: Scalars['UUID']['input'];
};

export enum TranscriptionStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  NotStarted = 'NotStarted',
  Pending = 'Pending',
  TimedOut = 'TimedOut'
}

export type TransferOwnershipInput = {
  memberId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
};

export type TrialProcessInput = {
  token: Scalars['GraphQLString']['input'];
};

export type TruncateGlobalTableInput = {
  table: GlobalTable;
};

export type UnfinishedRegistrationInput = {
  token: Scalars['GraphQLString']['input'];
};

/** Time window during which we query for unfinished registrations. */
export type UnfinishedRegistrationsWindow = {
  endsHoursAgo: Scalars['Int']['input'];
  startsHoursAgo: Scalars['Int']['input'];
};

export type UnlinkCaseInput = {
  caseId: Scalars['UUID']['input'];
  linkedCaseId: Scalars['UUID']['input'];
};

export type UnlinkCompanyFromPartnerInput = {
  motherId: Scalars['UUID']['input'];
  partnerId: Scalars['UUID']['input'];
};

export type UpdateAiHotlineSystemInstructionsInput = {
  shouldSynchronizeAllRegions: Scalars['Boolean']['input'];
  systemInstructions: Scalars['GraphQLString']['input'];
};

export type UpdateCompanyReportLabelInput = {
  labelId: Scalars['UUID']['input'];
  motherId: Scalars['UUID']['input'];
  name: Scalars['GraphQLString']['input'];
};

export type UpdateInstitutionOpenIdWithTokenInput = {
  openIdClientId: Scalars['GraphQLString']['input'];
  openIdClientSecret: Scalars['GraphQLString']['input'];
  openIdProviderUrl: Scalars['GraphQLString']['input'];
  token: Scalars['GraphQLString']['input'];
};

export type UpdateReportRatingInput = {
  rating: Scalars['GraphQLCaseRating']['input'];
};

export type UpsertEmployeesInput = {
  employees: Array<EmployeeAttributesInput>;
  motherId: Scalars['UUID']['input'];
};

export enum UseCase {
  Analytics = 'Analytics',
  Conflict = 'Conflict',
  Engagement = 'Engagement',
  Feedback = 'Feedback',
  Gift = 'Gift',
  Grievances = 'Grievances',
  Incident = 'Incident',
  Other = 'Other',
  Schools = 'Schools',
  Whistleblowing = 'Whistleblowing'
}

export type UserLoginInput = {
  /** Two factor authentication code */
  code?: InputMaybe<Scalars['GraphQLString']['input']>;
  email: Scalars['Email']['input'];
  /** describe type of user which wants to log in */
  loginType: UserLoginType;
  passwordPrehash: Scalars['GraphQLString']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['EncryptionVersion']['input']>;
};

export enum UserLoginType {
  FuAdmin = 'FuAdmin',
  PublicUser = 'PublicUser',
  Victim = 'Victim'
}

export type UserPreLoginInput = {
  email: Scalars['Email']['input'];
  /** describe type of user which wants to log in */
  loginType: UserLoginType;
};

export type UserSSOLoginInput = {
  email: Scalars['Email']['input'];
};

export type UserTokenPasswordInput = {
  /** Two factor authentication code */
  code?: InputMaybe<Scalars['GraphQLString']['input']>;
  name?: InputMaybe<Scalars['AllowedUserName']['input']>;
  nonce: Scalars['Base64UrlSafe']['input'];
  passwordPrehash: Scalars['Base64UrlSafe']['input'];
  privateKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  privateKeyRecovery?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  privateKeyRecoveryNonce?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  publicKey: Scalars['Base64UrlSafe']['input'];
  recoveryKeyEncrypted: Scalars['Base64UrlSafe']['input'];
  recoveryKeyEncryptedNonce: Scalars['Base64UrlSafe']['input'];
  recoveryKeySystemEncrypted?: InputMaybe<Scalars['Base64UrlSafe']['input']>;
  salt: Scalars['Base64UrlSafe']['input'];
  token: Scalars['GraphQLString']['input'];
};

export enum UserTypeType {
  CompanyVictim = 'CompanyVictim',
  FuAdmin = 'FuAdmin',
  Member = 'Member'
}

export enum Variant {
  exclude = 'exclude',
  include = 'include'
}

export enum VerificationStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type VerifyApiKeyInput = {
  token: Scalars['GraphQLString']['input'];
};

export type VerifyEmailInput = {
  clientType?: InputMaybe<SignUpClientType>;
  email: Scalars['Email']['input'];
  isPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaType?: InputMaybe<RecaptchaType>;
  token: Scalars['GraphQLString']['input'];
  trialLength?: InputMaybe<Scalars['GraphQLTrialLength']['input']>;
};

export type VerifyMemberSlackNotificationsInput = {
  motherId: Scalars['UUID']['input'];
  state: Scalars['GraphQLString']['input'];
};

export type VerifySlackIntegrationInput = {
  code: Scalars['GraphQLString']['input'];
  motherId: Scalars['UUID']['input'];
  state: Scalars['GraphQLString']['input'];
};

export enum VerifyVictimEmailResult {
  EmailAlreadyVerified = 'EmailAlreadyVerified',
  Error = 'Error',
  Success = 'Success'
}

export type VictimLoginInput = {
  identity: Scalars['GraphQLString']['input'];
  organizationalUnitId: Scalars['UUID']['input'];
  passwordPrehash: Scalars['GraphQLString']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  reportPassword?: InputMaybe<Scalars['GraphQLString']['input']>;
  version: Scalars['EncryptionVersion']['input'];
};

export type VictimPreLoginInput = {
  identity: Scalars['GraphQLString']['input'];
  organizationalUnitId: Scalars['UUID']['input'];
  reportPassword?: InputMaybe<Scalars['GraphQLString']['input']>;
};

export type VonageWebhookInput = {
  data: Scalars['JSON']['input'];
  token: Scalars['GraphQLString']['input'];
};

export enum WebhookStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Stopped = 'Stopped'
}

export enum WebhookType {
  InternalCommentCreated = 'InternalCommentCreated',
  MessageCreated = 'MessageCreated',
  ReportCreated = 'ReportCreated'
}

export type WorkingHoursDayInput = {
  from?: InputMaybe<Scalars['WorkingHour']['input']>;
  name: Day;
  to?: InputMaybe<Scalars['WorkingHour']['input']>;
};

type Chat_case_CompanyReport_Fragment = { __typename: 'CompanyReport', creationOrigin: CaseCreationOrigin, isDemo: boolean, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'Chat_case_CompanyReport_Fragment' };

type Chat_case_Submission_Fragment = { __typename: 'Submission', creationOrigin: CaseCreationOrigin, isDemo: boolean, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'Chat_case_Submission_Fragment' };

export type Chat_caseFragment =
  | Chat_case_CompanyReport_Fragment
  | Chat_case_Submission_Fragment
;

export type SendMessageMutationMutationVariables = Exact<{
  input: CreateCompanyReportFollowUpCommentInput;
  isVictim: Scalars['Boolean']['input'];
}>;


export type SendMessageMutationMutation = { createCompanyReportFollowUpComment: { __typename: 'CreateCompanyReportFollowUpCommentPayload', createdCompanyReportComment: { __typename: 'CompanyReportFollowUpComment', id: string, case:
        | { __typename: 'CompanyReport', id: string, updatedAt: string, lastChangeDate?: string, assignedMembers?: Array<{ __typename: 'Member', id: string }> }
        | { __typename: 'Submission', id: string, updatedAt: string, lastChangeDate?: string, assignedMembers?: Array<{ __typename: 'Member', id: string }> }
       } | null } | null };

export type EditCompanyReportNameVisibilityMutationMutationVariables = Exact<{
  input: EditCompanyReportNameVisibilityInput;
}>;


export type EditCompanyReportNameVisibilityMutationMutation = { editCompanyReportNameVisibility: { __typename: 'EditCompanyReportNameVisibilityPayload', case:
      | { __typename: 'CompanyReport', id: string, isNameHidden: boolean }
      | { __typename: 'Submission', id: string, isNameHidden: boolean }
     | null } | null };

type CompanyChatForm_case_CompanyReport_Fragment = { __typename: 'CompanyReport', id: string, isDemo: boolean, isNameHidden: boolean, encryptionKey: string | null, creationOrigin: CaseCreationOrigin, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup }, organizationalUnit: { __typename: 'Company', id: string, mother: { __typename: 'Company', id: string } | null, billing: { __typename: 'Billing', id: string, plan: Plan } | null }, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'CompanyChatForm_case_CompanyReport_Fragment' };

type CompanyChatForm_case_Submission_Fragment = { __typename: 'Submission', id: string, isDemo: boolean, isNameHidden: boolean, encryptionKey: string | null, creationOrigin: CaseCreationOrigin, organizationalUnit: { __typename: 'Company', id: string, mother: { __typename: 'Company', id: string } | null, billing: { __typename: 'Billing', id: string, plan: Plan } | null }, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'CompanyChatForm_case_Submission_Fragment' };

export type CompanyChatForm_caseFragment =
  | CompanyChatForm_case_CompanyReport_Fragment
  | CompanyChatForm_case_Submission_Fragment
;

export type CompanyReportFollowUpChatQueryQueryVariables = Exact<{
  caseId: Scalars['UUID']['input'];
  sourceLanguage?: InputMaybe<Language>;
  targetLanguage?: InputMaybe<Language>;
}>;


export type CompanyReportFollowUpChatQueryQuery = { case:
    | (
      { __typename: 'CompanyReport', hasMemberFollowUpComment: boolean, id: string, isNameHidden: boolean, translation: { __typename: 'CompanyReportTranslation', id: string, sourceLanguage: Language | null, targetLanguage: Language | null } | null, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup, name: string }, channel: { __typename: 'ReportSource', id: string, sourceType: ChannelType }, victim: { __typename: 'CompanyVictim', id: string } | null, organizationalUnit: { __typename: 'Company', id: string, isE2EE: boolean, billing: { __typename: 'Billing', id: string, plan: Plan } | null, workingHours: { __typename: 'WorkingHours', id: string, outsideWorkingHoursMessage: string | null, timezone: string | null, enabled: boolean | null, days: Array<{ __typename: 'WorkingHoursDay', name: Day, from: string | null, to: string | null }> | null } | null } }
      & { ' $fragmentRefs'?: { 'CompanyChatForm_case_CompanyReport_Fragment': CompanyChatForm_case_CompanyReport_Fragment;'Chat_case_CompanyReport_Fragment': Chat_case_CompanyReport_Fragment;'ReportStatusAlert_case_CompanyReport_Fragment': ReportStatusAlert_case_CompanyReport_Fragment;'ReportRating_case_CompanyReport_Fragment': ReportRating_case_CompanyReport_Fragment } }
    )
    | (
      { __typename: 'Submission', id: string, isNameHidden: boolean, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup, name: string }, channel: { __typename: 'ReportSource', id: string, sourceType: ChannelType }, victim: { __typename: 'CompanyVictim', id: string } | null, organizationalUnit: { __typename: 'Company', id: string, isE2EE: boolean, billing: { __typename: 'Billing', id: string, plan: Plan } | null, workingHours: { __typename: 'WorkingHours', id: string, outsideWorkingHoursMessage: string | null, timezone: string | null, enabled: boolean | null, days: Array<{ __typename: 'WorkingHoursDay', name: Day, from: string | null, to: string | null }> | null } | null } }
      & { ' $fragmentRefs'?: { 'CompanyChatForm_case_Submission_Fragment': CompanyChatForm_case_Submission_Fragment;'Chat_case_Submission_Fragment': Chat_case_Submission_Fragment;'ReportStatusAlert_case_Submission_Fragment': ReportStatusAlert_case_Submission_Fragment;'ReportRating_case_Submission_Fragment': ReportRating_case_Submission_Fragment } }
    )
   };

export type CompanyReportFollowUpActivitiesQueryQueryVariables = Exact<{
  caseId: Scalars['UUID']['input'];
  sourceLanguage?: InputMaybe<Language>;
  targetLanguage?: InputMaybe<Language>;
  followUpActivitiesFirst: Scalars['Int']['input'];
  followUpActivitiesAfter?: InputMaybe<Scalars['String']['input']>;
  followUpActivitiesNewestFirst?: InputMaybe<Scalars['Boolean']['input']>;
  isVictim: Scalars['Boolean']['input'];
}>;


export type CompanyReportFollowUpActivitiesQueryQuery = { case:
    | { __typename: 'CompanyReport', id: string, followUpActivities: { __typename: 'CompanyReportFollowUpCommentCursorConnection', nextCursor: string | null, items: Array<(
          { __typename: 'CompanyReportFollowUpComment', id: string, author:
            | { __typename: 'CompanyVictim', id: string }
            | { __typename: 'Member', id: string }
           | null }
          & { ' $fragmentRefs'?: { 'FollowUpChatMessage_followUpActivityNodeFragment': FollowUpChatMessage_followUpActivityNodeFragment } }
        )> } }
    | { __typename: 'Submission', id: string, followUpActivities: { __typename: 'CompanyReportFollowUpCommentCursorConnection', nextCursor: string | null, items: Array<(
          { __typename: 'CompanyReportFollowUpComment', id: string, author:
            | { __typename: 'CompanyVictim', id: string }
            | { __typename: 'Member', id: string }
           | null }
          & { ' $fragmentRefs'?: { 'FollowUpChatMessage_followUpActivityNodeFragment': FollowUpChatMessage_followUpActivityNodeFragment } }
        )> } }
   };

export type NewFollowUpReportActivitySubscriptionSubscriptionVariables = Exact<{
  caseId: Scalars['UUID']['input'];
  sourceLanguage?: InputMaybe<Language>;
  targetLanguage?: InputMaybe<Language>;
  isVictim: Scalars['Boolean']['input'];
}>;


export type NewFollowUpReportActivitySubscriptionSubscription = { newCompanyReportFollowUpActivity: Array<(
    { __typename: 'CompanyReportFollowUpComment', id: string, author:
      | { __typename: 'CompanyVictim', id: string }
      | { __typename: 'Member', id: string }
     | null }
    & { ' $fragmentRefs'?: { 'FollowUpChatMessage_followUpActivityNodeFragment': FollowUpChatMessage_followUpActivityNodeFragment } }
  )> };

export type FollowUpChatMessage_followUpActivityNodeFragment = (
  { __typename: 'CompanyReportFollowUpComment', id: string, isAuthorRedacted: boolean, isNameHidden: boolean | null, deletedAt: string | null, readByMemberIds: Array<string>, isMessageReadByVictim: boolean | null, createdAt: string | null, author:
    | { __typename: 'CompanyVictim', id: string }
    | { __typename: 'Member', id: string, name: string | null, profileImageUrl: string | null }
   | null, translation: { __typename: 'CompanyReportFollowUpCommentTranslation', ciphertext: string | null, nonce: string, sourceLanguage: Language | null, targetLanguage: Language | null } | null, case:
    | { __typename: 'CompanyReport', id: string, updatedAt: string, lastChangeDate?: string, encryptionKey: string | null, translation: { __typename: 'CompanyReportTranslation', id: string, body: string, bodyNonce: string } | null, organizationalUnit: { __typename: 'Company', id: string, organizationalUnitName: string, mother: { __typename: 'Company', id: string } | null } }
    | { __typename: 'Submission', id: string, updatedAt: string, lastChangeDate?: string, encryptionKey: string | null, organizationalUnit: { __typename: 'Company', id: string, organizationalUnitName: string, mother: { __typename: 'Company', id: string } | null } }
  , attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }> }
  & { ' $fragmentRefs'?: { 'UseMarkMessagesAsReadFragments_commentFragment': UseMarkMessagesAsReadFragments_commentFragment } }
) & { ' $fragmentName'?: 'FollowUpChatMessage_followUpActivityNodeFragment' };

export type UpdateReportRatingMutationVariables = Exact<{
  input: UpdateReportRatingInput;
}>;


export type UpdateReportRatingMutation = { updateReportRating: { __typename: 'UpdateReportRatingPayload', case:
      | { __typename: 'CompanyReport', id: string, rating: CaseRating | null, ratedAt: string | null }
      | { __typename: 'Submission', id: string, rating: CaseRating | null, ratedAt: string | null }
     | null } | null };

type ReportRating_case_CompanyReport_Fragment = { __typename: 'CompanyReport', id: string, rating: CaseRating | null, ratedAt: string | null, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup }, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'ReportRating_case_CompanyReport_Fragment' };

type ReportRating_case_Submission_Fragment = { __typename: 'Submission', id: string, rating: CaseRating | null, ratedAt: string | null, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup }, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'ReportRating_case_Submission_Fragment' };

export type ReportRating_caseFragment =
  | ReportRating_case_CompanyReport_Fragment
  | ReportRating_case_Submission_Fragment
;

type ReportStatusAlert_case_CompanyReport_Fragment = { __typename: 'CompanyReport', id: string, isHiddenFromStatistics: boolean, isDemo: boolean, status: { __typename: 'CaseStatusType', groupName: CaseStatusGroup, id: string }, channel: { __typename: 'ReportSource', id: string, sourceType: ChannelType }, organizationalUnit: { __typename: 'Company', id: string, workingHours: { __typename: 'WorkingHours', id: string, enabled: boolean | null, outsideWorkingHoursMessage: string | null } | null }, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'ReportStatusAlert_case_CompanyReport_Fragment' };

type ReportStatusAlert_case_Submission_Fragment = { __typename: 'Submission', id: string, isHiddenFromStatistics: boolean, isDemo: boolean, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup }, channel: { __typename: 'ReportSource', id: string, sourceType: ChannelType }, organizationalUnit: { __typename: 'Company', id: string, workingHours: { __typename: 'WorkingHours', id: string, enabled: boolean | null, outsideWorkingHoursMessage: string | null } | null }, victim: { __typename: 'CompanyVictim', id: string } | null } & { ' $fragmentName'?: 'ReportStatusAlert_case_Submission_Fragment' };

export type ReportStatusAlert_caseFragment =
  | ReportStatusAlert_case_CompanyReport_Fragment
  | ReportStatusAlert_case_Submission_Fragment
;

export type ReopenCompanyReportMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type ReopenCompanyReportMutationMutation = { reopenCompanyReport: { __typename: 'ReopenCompanyReportPayload', case:
      | { __typename: 'CompanyReport', id: string, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup } }
      | { __typename: 'Submission', id: string, status: { __typename: 'CaseStatusType', id: string, groupName: CaseStatusGroup } }
     | null } | null };

export type CustomFormItemsQueryQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['CompanyReportCategoryGlobalId']['input']>;
  includeDeletedOptions?: InputMaybe<Scalars['Boolean']['input']>;
  reportSourceId: Scalars['ID']['input'];
}>;


export type CustomFormItemsQueryQuery = { formItems: Array<{ __typename: 'FormItem', id: string, formItemId: string, type: FormItemType, hasHint: boolean, deletedAt: string | null, isRequired: boolean, labelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }>, hintTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null, options: Array<{ __typename: 'FormItemOption', order: number | null, id: string, deletedAt: string | null, labelTranslations: Array<{ __typename: 'Translated', translation: string, language: Language }> }>, scaleStartLabelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null, scaleEndLabelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null }> };

export type FormElement_formItemFragment = { __typename: 'FormItem', id: string, formItemId: string, type: FormItemType, hasHint: boolean, deletedAt: string | null, isRequired: boolean, labelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }>, hintTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null, options: Array<{ __typename: 'FormItemOption', id: string, deletedAt: string | null, order: number | null, labelTranslations: Array<{ __typename: 'Translated', translation: string, language: Language }> }>, scaleStartLabelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null, scaleEndLabelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null } & { ' $fragmentName'?: 'FormElement_formItemFragment' };

type FormItemsAnswers_case_CompanyReport_Fragment = { __typename: 'CompanyReport', id: string, answers: Array<(
    { __typename: 'FormItemAnswer' }
    & { ' $fragmentRefs'?: { 'useFormItemsAnswers_formItemAnswerFragment': useFormItemsAnswers_formItemAnswerFragment } }
  )> } & { ' $fragmentName'?: 'FormItemsAnswers_case_CompanyReport_Fragment' };

type FormItemsAnswers_case_Submission_Fragment = { __typename: 'Submission', id: string, answers: Array<(
    { __typename: 'FormItemAnswer' }
    & { ' $fragmentRefs'?: { 'useFormItemsAnswers_formItemAnswerFragment': useFormItemsAnswers_formItemAnswerFragment } }
  )> } & { ' $fragmentName'?: 'FormItemsAnswers_case_Submission_Fragment' };

export type FormItemsAnswers_caseFragment =
  | FormItemsAnswers_case_CompanyReport_Fragment
  | FormItemsAnswers_case_Submission_Fragment
;

export type ReportStatus_translatedCaseStatusFragment = { __typename: 'CaseStatusType', id: string, color: string, name: string, groupName: CaseStatusGroup } & { ' $fragmentName'?: 'ReportStatus_translatedCaseStatusFragment' };

export type UseCreateRedactedReportQueryQueryVariables = Exact<{
  caseId: Scalars['UUID']['input'];
  sourceLanguage?: InputMaybe<Language>;
  targetLanguage?: InputMaybe<Language>;
  followUpFirst: Scalars['Int']['input'];
  commentsRowsPerPage: Scalars['Int']['input'];
  isVictim: Scalars['Boolean']['input'];
}>;


export type UseCreateRedactedReportQueryQuery = { case:
    | (
      { __typename: 'CompanyReport', id: string, encryptionKey: string | null, category: { __typename: 'CompanyReportCategory', id: string }, organizationalUnit: { __typename: 'Company', id: string, isE2EE: boolean, recipients: Array<(
          { __typename: 'Member' }
          & { ' $fragmentRefs'?: { 'usePrepareReportPayloadFragments_memberFragment': usePrepareReportPayloadFragments_memberFragment } }
        )> }, channel: { __typename: 'ReportSource', id: string, defaultLanguage: Language }, closingCommentTranslation: { __typename: 'ExternalTranslation', id: string, body: string, bodyNonce: string } | null, answers: Array<(
        { __typename: 'FormItemAnswer', id: string, formItem: { __typename: 'FormItem', id: string, formItemId: string, type: FormItemType }, attachments: Array<{ __typename: 'Attachment', id: string, mimetype: string, name: string, url: string }> }
        & { ' $fragmentRefs'?: { 'usePrepareFormItemAnswersForMutationFragments_answerFragment': usePrepareFormItemAnswersForMutationFragments_answerFragment;'useManageReportCustomInputsFragments_answerFragment': useManageReportCustomInputsFragments_answerFragment } }
      )>, followUpActivities: { __typename: 'CompanyReportFollowUpCommentCursorConnection', items: Array<(
          { __typename: 'CompanyReportFollowUpComment', id: string, translation: { __typename: 'CompanyReportFollowUpCommentTranslation', id: string, ciphertext: string | null, nonce: string } | null, attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }> }
          & { ' $fragmentRefs'?: { 'FollowUpChatMessage_followUpActivityNodeFragment': FollowUpChatMessage_followUpActivityNodeFragment } }
        )> }, comments: { __typename: 'CompanyReportInternalCommentsConnection', totalCount: number, items: Array<{ __typename: 'CompanyReportInternalComment', id: string, translation: { __typename: 'CompanyReportInternalCommentTranslation', id: string, ciphertext: string | null, nonce: string } | null, parentComment: { __typename: 'CompanyReportInternalComment', id: string } | null, attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }> }> }, attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }> }
      & { ' $fragmentRefs'?: { 'UseReportBody_reportNoVariablesFragment': UseReportBody_reportNoVariablesFragment } }
    )
    | { __typename: 'Submission', id: string, encryptionKey: string | null, organizationalUnit: { __typename: 'Company', id: string, isE2EE: boolean, recipients: Array<(
          { __typename: 'Member' }
          & { ' $fragmentRefs'?: { 'usePrepareReportPayloadFragments_memberFragment': usePrepareReportPayloadFragments_memberFragment } }
        )> }, channel: { __typename: 'ReportSource', id: string, defaultLanguage: Language }, closingCommentTranslation: { __typename: 'ExternalTranslation', id: string, body: string, bodyNonce: string } | null, answers: Array<(
        { __typename: 'FormItemAnswer', id: string, formItem: { __typename: 'FormItem', id: string, formItemId: string, type: FormItemType }, attachments: Array<{ __typename: 'Attachment', id: string, mimetype: string, name: string, url: string }> }
        & { ' $fragmentRefs'?: { 'usePrepareFormItemAnswersForMutationFragments_answerFragment': usePrepareFormItemAnswersForMutationFragments_answerFragment;'useManageReportCustomInputsFragments_answerFragment': useManageReportCustomInputsFragments_answerFragment } }
      )>, followUpActivities: { __typename: 'CompanyReportFollowUpCommentCursorConnection', items: Array<(
          { __typename: 'CompanyReportFollowUpComment', id: string, translation: { __typename: 'CompanyReportFollowUpCommentTranslation', id: string, ciphertext: string | null, nonce: string } | null, attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }> }
          & { ' $fragmentRefs'?: { 'FollowUpChatMessage_followUpActivityNodeFragment': FollowUpChatMessage_followUpActivityNodeFragment } }
        )> }, comments: { __typename: 'CompanyReportInternalCommentsConnection', totalCount: number, items: Array<{ __typename: 'CompanyReportInternalComment', id: string, translation: { __typename: 'CompanyReportInternalCommentTranslation', id: string, ciphertext: string | null, nonce: string } | null, parentComment: { __typename: 'CompanyReportInternalComment', id: string } | null, attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }> }> }, attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }> }
  , systemInfo: (
    { __typename: 'System', id: string, publicKey: string }
    & { ' $fragmentRefs'?: { 'usePrepareReportPayloadFragments_systemFragment': usePrepareReportPayloadFragments_systemFragment } }
  ) | null, memberViewer: { __typename: 'Member', id: string, keys: { __typename: 'UserKeys', id: string, publicKey: string | null } } | null };

export type CreateRedactedReportMutationVariables = Exact<{
  input: CreateRedactedReportInput;
}>;


export type CreateRedactedReportMutation = { createRedactedReport: { __typename: 'CreateRedactedReportPayload', createdCase:
      | { __typename: 'CompanyReport', id: string, tag: string }
      | { __typename: 'Submission', id: string, tag: string }
     | null } | null };

export type useFormItemsAnswers_formItemAnswerFragment = { __typename: 'FormItemAnswer', id: string, values: Array<string>, translatedValues: Array<string>, attachments: Array<{ __typename: 'Attachment', id: string, name: string, url: string, mimetype: string }>, formItem: { __typename: 'FormItem', id: string, formItemId: string, type: FormItemType, labelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }>, options: Array<{ __typename: 'FormItemOption', id: string, order: number | null, labelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> }>, scaleStartLabelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null, scaleEndLabelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> | null, matrixConfig: { __typename: 'MatrixFormItemConfigurationType', options: Array<{ __typename: 'MatrixFormItemElement', id: string, labelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> }>, questions: Array<{ __typename: 'MatrixFormItemElement', id: string, labelTranslations: Array<{ __typename: 'Translated', language: Language, translation: string }> }> } | null }, matrixValues: Array<{ __typename: 'MatrixAnswerValue', optionId: string, questionId: string }> } & { ' $fragmentName'?: 'useFormItemsAnswers_formItemAnswerFragment' };

export type useManageReportCustomInputsFragments_answerFragment = (
  { __typename: 'FormItemAnswer', id: string, values: Array<string>, attachments: Array<{ __typename: 'Attachment', id: string, name: string }>, formItem: { __typename: 'FormItem', id: string, formItemId: string, type: FormItemType } }
  & { ' $fragmentRefs'?: { 'usePrepareFormItemAnswersForMutationFragments_answerFragment': usePrepareFormItemAnswersForMutationFragments_answerFragment } }
) & { ' $fragmentName'?: 'useManageReportCustomInputsFragments_answerFragment' };

export type UseMarkMessagesAsReadFragments_commentFragment = { __typename: 'CompanyReportFollowUpComment', id: string, readByMemberIds: Array<string>, isMessageReadByVictim: boolean | null, caseId: string, author:
    | { __typename: 'CompanyVictim', id: string }
    | { __typename: 'Member', id: string }
   | null, case:
    | { __typename: 'CompanyReport', id: string, organizationalUnit: { __typename: 'Company', id: string, mother: { __typename: 'Company', id: string } | null } }
    | { __typename: 'Submission', id: string, organizationalUnit: { __typename: 'Company', id: string, mother: { __typename: 'Company', id: string } | null } }
   } & { ' $fragmentName'?: 'UseMarkMessagesAsReadFragments_commentFragment' };

export type MarkAsReadByMemberMutationMutationVariables = Exact<{
  input: MarkAsReadCompanyFollowUpCommentsByMemberInput;
}>;


export type MarkAsReadByMemberMutationMutation = { markAsReadCompanyFollowUpCommentsByMember: { __typename: 'MarkAsReadCompanyFollowUpCommentsByMemberPayload', case:
      | { __typename: 'CompanyReport', id: string, updatedAt: string, unseenFollowUpCommentsCount: number }
      | { __typename: 'Submission', id: string, updatedAt: string, unseenFollowUpCommentsCount: number }
     } | null };

export type MarkAsReadByVictimMutationMutationVariables = Exact<{
  input: MarkAsReadCompanyFollowUpCommentsByVictimInput;
}>;


export type MarkAsReadByVictimMutationMutation = { markAsReadCompanyFollowUpCommentsByVictim: { __typename: 'MarkAsReadCompanyFollowUpCommentsByVictimPayload', success: boolean | null } | null };

export type usePrepareFormItemAnswersForMutationFragments_answerFragment = { __typename: 'FormItemAnswer', id: string, values: Array<string>, formItem: { __typename: 'FormItem', id: string, type: FormItemType, formItemId: string } } & { ' $fragmentName'?: 'usePrepareFormItemAnswersForMutationFragments_answerFragment' };

export type HookCustomFormItemsQueryQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['CompanyReportCategoryGlobalId']['input']>;
  reportSourceId: Scalars['ID']['input'];
}>;


export type HookCustomFormItemsQueryQuery = { formItems: Array<{ __typename: 'FormItem', id: string, formItemId: string, isRequired: boolean, type: FormItemType }> };

export type usePrepareReportPayloadFragments_systemFragment = { __typename: 'System', id: string, publicKey: string } & { ' $fragmentName'?: 'usePrepareReportPayloadFragments_systemFragment' };

export type usePrepareReportPayloadFragments_memberFragment = { __typename: 'Member', id: string, keys: { __typename: 'UserKeys', id: string, publicKey: string | null } } & { ' $fragmentName'?: 'usePrepareReportPayloadFragments_memberFragment' };

export type UseReportBody_reportVariablesFragment = { __typename: 'CompanyReport', id: string, encryptionKey: string | null, translation: { __typename: 'CompanyReportTranslation', id: string, body: string, bodyNonce: string } | null } & { ' $fragmentName'?: 'UseReportBody_reportVariablesFragment' };

export type UseReportBody_reportNoVariablesFragment = { __typename: 'CompanyReport', id: string, encryptionKey: string | null, translation: { __typename: 'CompanyReportTranslation', id: string, body: string, bodyNonce: string } | null } & { ' $fragmentName'?: 'UseReportBody_reportNoVariablesFragment' };

export type ReportExportLogMutationVariables = Exact<{
  input: CreateExportActivityLogItemInput;
}>;


export type ReportExportLogMutation = { createExportActivityLogItem: { __typename: 'CreateExportActivityLogItemPayload', success: boolean } | null };

export type useUnreadFollowUpMessages_followupCommentFragment = { __typename: 'CompanyReportFollowUpComment', id: string, readByMemberIds: Array<string>, isMessageReadByVictim: boolean | null, author:
    | { __typename: 'CompanyVictim', id: string }
    | { __typename: 'Member', id: string }
   | null } & { ' $fragmentName'?: 'useUnreadFollowUpMessages_followupCommentFragment' };

export const Chat_caseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Chat_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"isDemo"}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Chat_caseFragment, unknown>;
export const CompanyChatForm_caseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyChatForm_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDemo"}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"creationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CompanyChatForm_caseFragment, unknown>;
export const UseMarkMessagesAsReadFragments_commentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UseMarkMessagesAsReadFragments_commentFragment, unknown>;
export const FollowUpChatMessage_followUpActivityNodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpChatMessage_followUpActivityNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ciphertext"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"targetLanguage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAuthorRedacted"}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastChangeDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}}}]}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FollowUpChatMessage_followUpActivityNodeFragment, unknown>;
export const ReportRating_caseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportRating_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"ratedAt"}}]}}]} as unknown as DocumentNode<ReportRating_caseFragment, unknown>;
export const ReportStatusAlert_caseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportStatusAlert_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isHiddenFromStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"isDemo"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"outsideWorkingHoursMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReportStatusAlert_caseFragment, unknown>;
export const FormElement_formItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormElement_formItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hasHint"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelIdHack"}}}]},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hintTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDeletedOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleStartLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleEndLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]} as unknown as DocumentNode<FormElement_formItemFragment, unknown>;
export const useFormItemsAnswers_formItemAnswerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useFormItemsAnswers_formItemAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItemAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"translatedValues"},"name":{"kind":"Name","value":"values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDeleted"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"includeOtherOptions"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleStartLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleEndLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matrixConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"matrixValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"optionId"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}}]}}]}}]} as unknown as DocumentNode<useFormItemsAnswers_formItemAnswerFragment, unknown>;
export const FormItemsAnswers_caseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormItemsAnswers_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"useFormItemsAnswers_formItemAnswer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useFormItemsAnswers_formItemAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItemAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"translatedValues"},"name":{"kind":"Name","value":"values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDeleted"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"includeOtherOptions"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleStartLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleEndLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matrixConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"matrixValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"optionId"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}}]}}]}}]} as unknown as DocumentNode<FormItemsAnswers_caseFragment, unknown>;
export const ReportStatus_translatedCaseStatusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportStatus_translatedCaseStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseStatusType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]} as unknown as DocumentNode<ReportStatus_translatedCaseStatusFragment, unknown>;
export const usePrepareFormItemAnswersForMutationFragments_answerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usePrepareFormItemAnswersForMutationFragments_answer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItemAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode<usePrepareFormItemAnswersForMutationFragments_answerFragment, unknown>;
export const useManageReportCustomInputsFragments_answerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useManageReportCustomInputsFragments_answer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItemAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usePrepareFormItemAnswersForMutationFragments_answer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usePrepareFormItemAnswersForMutationFragments_answer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItemAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}}]} as unknown as DocumentNode<useManageReportCustomInputsFragments_answerFragment, unknown>;
export const usePrepareReportPayloadFragments_systemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usePrepareReportPayloadFragments_system"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"System"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicKey"}}]}}]} as unknown as DocumentNode<usePrepareReportPayloadFragments_systemFragment, unknown>;
export const usePrepareReportPayloadFragments_memberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usePrepareReportPayloadFragments_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicKey"}}]}}]}}]} as unknown as DocumentNode<usePrepareReportPayloadFragments_memberFragment, unknown>;
export const UseReportBody_reportVariablesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseReportBody_reportVariables"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}}]}}]} as unknown as DocumentNode<UseReportBody_reportVariablesFragment, unknown>;
export const UseReportBody_reportNoVariablesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseReportBody_reportNoVariables"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}}]}}]} as unknown as DocumentNode<UseReportBody_reportNoVariablesFragment, unknown>;
export const useUnreadFollowUpMessages_followupCommentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useUnreadFollowUpMessages_followupComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}}]}}]} as unknown as DocumentNode<useUnreadFollowUpMessages_followupCommentFragment, unknown>;
export const SendMessageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCompanyReportFollowUpCommentInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompanyReportFollowUpComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdCompanyReportComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastChangeDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"assignedMembers"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendMessageMutationMutation, SendMessageMutationMutationVariables>;
export const EditCompanyReportNameVisibilityMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditCompanyReportNameVisibilityMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditCompanyReportNameVisibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editCompanyReportNameVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}}]}}]}}]}}]} as unknown as DocumentNode<EditCompanyReportNameVisibilityMutationMutation, EditCompanyReportNameVisibilityMutationMutationVariables>;
export const CompanyReportFollowUpChatQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyReportFollowUpChatQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"caseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMemberFollowUpComment"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"targetLanguage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Submission"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isE2EE"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outsideWorkingHoursMessage"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyChatForm_case"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Chat_case"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportStatusAlert_case"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportRating_case"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyChatForm_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDemo"}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"creationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Chat_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creationOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"isDemo"}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportStatusAlert_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isHiddenFromStatistics"}},{"kind":"Field","name":{"kind":"Name","value":"isDemo"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"outsideWorkingHoursMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportRating_case"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"victim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"ratedAt"}}]}}]} as unknown as DocumentNode<CompanyReportFollowUpChatQueryQuery, CompanyReportFollowUpChatQueryQueryVariables>;
export const CompanyReportFollowUpActivitiesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyReportFollowUpActivitiesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"followUpActivitiesFirst"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"followUpActivitiesAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"followUpActivitiesNewestFirst"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"caseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"followUpActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"followUpActivitiesFirst"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"followUpActivitiesAfter"}}},{"kind":"Argument","name":{"kind":"Name","value":"newestFirst"},"value":{"kind":"Variable","name":{"kind":"Name","value":"followUpActivitiesNewestFirst"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpChatMessage_followUpActivityNode"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpChatMessage_followUpActivityNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ciphertext"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"targetLanguage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAuthorRedacted"}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastChangeDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}}}]}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"}}]}}]} as unknown as DocumentNode<CompanyReportFollowUpActivitiesQueryQuery, CompanyReportFollowUpActivitiesQueryQueryVariables>;
export const NewFollowUpReportActivitySubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NewFollowUpReportActivitySubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newCompanyReportFollowUpActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"caseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpChatMessage_followUpActivityNode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpChatMessage_followUpActivityNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ciphertext"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"targetLanguage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAuthorRedacted"}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastChangeDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}}}]}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"}}]}}]} as unknown as DocumentNode<NewFollowUpReportActivitySubscriptionSubscription, NewFollowUpReportActivitySubscriptionSubscriptionVariables>;
export const UpdateReportRatingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReportRating"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReportRatingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"ratedAt"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateReportRatingMutation, UpdateReportRatingMutationVariables>;
export const ReopenCompanyReportMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReopenCompanyReportMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reopenCompanyReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReopenCompanyReportMutationMutation, ReopenCompanyReportMutationMutationVariables>;
export const CustomFormItemsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomFormItemsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportCategoryGlobalId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDeletedOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportSourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportSourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hasHint"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSourceId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hintTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDeletedOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"labelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleStartLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scaleEndLabelTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<CustomFormItemsQueryQuery, CustomFormItemsQueryQueryVariables>;
export const UseCreateRedactedReportQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UseCreateRedactedReportQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"followUpFirst"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commentsRowsPerPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"caseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isE2EE"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"usePrepareReportPayloadFragments_member"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingCommentTranslation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usePrepareFormItemAnswersForMutationFragments_answer"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"useManageReportCustomInputsFragments_answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"followUpActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"followUpFirst"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ciphertext"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpChatMessage_followUpActivityNode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"rowsPerPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commentsRowsPerPage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ciphertext"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseReportBody_reportNoVariables"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicKey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usePrepareReportPayloadFragments_system"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicKey"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usePrepareFormItemAnswersForMutationFragments_answer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItemAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usePrepareReportPayloadFragments_member"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicKey"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"useManageReportCustomInputsFragments_answer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormItemAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usePrepareFormItemAnswersForMutationFragments_answer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpChatMessage_followUpActivityNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportFollowUpComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyVictim"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceLanguage"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ciphertext"}},{"kind":"Field","name":{"kind":"Name","value":"nonce"}},{"kind":"Field","name":{"kind":"Name","value":"sourceLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"targetLanguage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAuthorRedacted"}},{"kind":"Field","name":{"kind":"Name","value":"isNameHidden"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"readByMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"isMessageReadByVictim"}},{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastChangeDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isVictim"}}}]}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationalUnitName"}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseMarkMessagesAsReadFragments_comment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseReportBody_reportNoVariables"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"encryptionKey"}},{"kind":"Field","name":{"kind":"Name","value":"translation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"bodyNonce"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usePrepareReportPayloadFragments_system"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"System"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicKey"}}]}}]} as unknown as DocumentNode<UseCreateRedactedReportQueryQuery, UseCreateRedactedReportQueryQueryVariables>;
export const CreateRedactedReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRedactedReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRedactedReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRedactedReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdCase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRedactedReportMutation, CreateRedactedReportMutationVariables>;
export const MarkAsReadByMemberMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAsReadByMemberMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkAsReadCompanyFollowUpCommentsByMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsReadCompanyFollowUpCommentsByMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"unseenFollowUpCommentsCount"}}]}}]}}]}}]} as unknown as DocumentNode<MarkAsReadByMemberMutationMutation, MarkAsReadByMemberMutationMutationVariables>;
export const MarkAsReadByVictimMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAsReadByVictimMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkAsReadCompanyFollowUpCommentsByVictimInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsReadCompanyFollowUpCommentsByVictim"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<MarkAsReadByVictimMutationMutation, MarkAsReadByVictimMutationMutationVariables>;
export const HookCustomFormItemsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HookCustomFormItemsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyReportCategoryGlobalId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportSourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reportSourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSourceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSourceId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<HookCustomFormItemsQueryQuery, HookCustomFormItemsQueryQueryVariables>;
export const ReportExportLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportExportLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateExportActivityLogItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExportActivityLogItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ReportExportLogMutation, ReportExportLogMutationVariables>;